/** English UI strings — source of truth for MessageKey. */
export const en = {
  // Shell / chrome
  "app.brand": "SemantiCAD",
  "palette.explorer": "Explorer",
  "palette.drawings": "Drawings",
  "palette.drawingsShort": "Drawings",
  "palette.stock": "Stock catalog",
  "palette.stockShort": "Stock",
  "palette.profile": "Profile",
  "palette.profileShort": "Profile",
  "palette.signOutShort": "Out",
  "palette.navPrimary": "Main navigation",
  "palette.select": "Select",
  "palette.measure": "Measure",
  "palette.bom": "BOM",
  "palette.reports": "Reports",
  "palette.orchestration": "Orchestration panel",
  "palette.erpShort": "ERP",
  "palette.erp": "Workshop ERP",
  "palette.rfq": "RFQ",
  "palette.rfqShort": "RFQ",
  "palette.aiShort": "AI",
  "palette.home": "Home",
  "palette.homeShort": "Home",

  "sidebar.ariaMain": "Main",
  "sidebar.markAria": "SemantiCAD home",
  "sidebar.orgMarkAria": "{name} home",
  "sidebar.show": "Show sidebar",
  "sidebar.collapse": "Collapse sidebar",
  "sidebar.openMenu": "Open menu",
  "sidebar.closeMenu": "Close menu",
  "sidebar.workspace": "Workspace",
  "sidebar.production": "Production",
  "sidebar.group.ai": "AI",
  "sidebar.group.data": "Data",
  "sidebar.documents": "Documents",
  "sidebar.agents": "Agents",
  "sidebar.soon": "Soon",
  "sidebar.comingSoon": "Coming soon",
  "agents.search": "Search agents",
  "agents.col.agent": "Agent",
  "agents.col.does": "What it does",
  "agents.col.where": "Where it runs",
  "agents.col.status": "Status",
  "agents.status.active": "Active",
  "agents.status.soon": "Coming soon",
  "agents.status.code": "Code",
  "agents.group.rfq": "RFQ flow",
  "agents.group.chat": "Drawing chat",
  "agents.where.rfq": "RFQ",
  "agents.where.parse": "File parsing",
  "agents.where.ai": "AI",
  "agents.where.none": "—",
  "agents.noMatch": "No agent matches “{query}”.",
  "agents.name.intake": "1 Intake",
  "agents.does.intake": "Reads mail/Excel/photo/CAD and maps qty, dates and files to lines.",
  "agents.name.geometry": "2 Geometry decision",
  "agents.does.geometry": "Picks the winner when extraction methods conflict, or says uncertain.",
  "agents.name.triage": "3 Triage",
  "agents.does.triage": "Finds gaps and conflicts, drafts the customer question mail, and never sends it.",
  "agents.name.wait": "4 Customer wait",
  "agents.does.wait": "Fills qty, date and material when the reply arrives.",
  "agents.name.material": "5 Material & substitute",
  "agents.does.material": "Matches stock, suggests substitutes, and asks for approval.",
  "agents.name.route": "6 Make/buy & route",
  "agents.does.route": "Seeds the method and route on each line.",
  "agents.name.supplier": "7 Supplier",
  "agents.does.supplier": "Drafts the supplier question mail and a last-price hint.",
  "agents.name.auditor": "8 Auditor",
  "agents.does.auditor": "Catches internal contradictions in the quote.",
  "agents.name.margin": "9 Margin suggestion",
  "agents.does.margin": "Suggests a margin only. A human approves.",
  "agents.name.cost": "Cost",
  "agents.does.cost": "Setup + run × qty, material + labour + machine. Code, not an agent.",
  "agents.name.memory": "10 Memory",
  "agents.does.memory": "Similar past jobs and human corrections.",
  "agents.name.highway": "Highway",
  "agents.does.highway": "Runs 1–10 in order and stops at the first human gate.",
  "agents.name.ask": "Ask orchestrator",
  "agents.does.ask": "Answers drawing questions by calling tools.",
  "agents.name.specialists": "Specialists",
  "agents.does.specialists": "Geometry, cost and risk reports, then a synthesis.",
  "agents.name.recommendations": "Recommendations",
  "agents.does.recommendations": "Shop recommendations for a drawing.",
  "sidebar.stock": "Stock & Materials",
  "sidebar.integrations": "Integrations",
  "notFound.code": "404",
  "notFound.title": "Page not found",
  "notFound.body": "That address isn't a page in SemantiCAD.",
  "notFound.home": "Back to home",
  "sidebar.settings": "Settings",
  "sidebar.hint.home": "Dashboard, shortcuts, and recent data",
  "sidebar.hint.drawings": "Parts, BOMs, and catalogs",
  "sidebar.hint.rfq": "Quotes, customers, and suppliers",
  "sidebar.hint.erp": "Orders, stock, and the shop floor",
  "sidebar.hint.ai": "Ask SemantiCAD about a job",
  "sidebar.hint.profile": "Account, team, and workspace",
  "sidebar.hint.customers": "Customers grouped from RFQ emails",
  "sidebar.hint.integrations": "Integrations aren't available yet.",
  "palette.customers": "Customers",

  "customers.title": "Customers",
  "customers.sub": "Grouped by the email on each RFQ.",
  "customers.search": "Search name, email or domain",
  "customers.notificationsEmpty": "Nothing is waiting on you.",
  "customers.filters": "Filter customers",
  "customers.filter.all": "All",
  "customers.filter.active": "Active",
  "customers.filter.open": "Has open quotes",
  "customers.filter.won": "Won before",
  "customers.col.customer": "Customer",
  "customers.col.company": "Company",
  "customers.companyHint": "Email domain",
  "customers.col.rfqs": "RFQs",
  "customers.col.open": "Open quotes",
  "customers.col.quoted": "Quoted total",
  "customers.col.wonLost": "Won / Lost",
  "customers.col.lastRfq": "Last RFQ",
  "customers.col.activity": "Last activity",
  "customers.col.event": "Event",
  "customers.col.date": "Date",
  "customers.col.rfq": "RFQ",
  "customers.field.email": "Email",
  "customers.field.domain": "Domain",
  "customers.field.firstSeen": "First seen",
  "customers.col.parts": "Parts",
  "customers.col.status": "Status",
  "customers.empty": "No customers yet. A customer appears when an RFQ carries an email.",
  "customers.noMatch": "No customers match this filter.",
  "customers.back": "Customers",
  "customers.missing": "No customer matches this address.",
  "customers.firstSeen": "First seen {date}",
  "customers.kpi.rfqs": "RFQs",
  "customers.kpi.quoted": "Quoted",
  "customers.kpi.won": "Won",
  "customers.kpi.win": "Win rate",
  "customers.kpi.response": "Response",
  "customers.kpi.responseHint": "Average from created to quote sent",
  "customers.history": "RFQs",
  "customers.activity": "Activity",
  "customers.activityEmpty": "No dated events on these RFQs.",
  "customers.mailError": "Mail inbox could not be loaded.",
  "customers.due": "Due",
  "customers.quote": "Quote",
  "customers.target": "Target {amount}",
  "customers.contacts": "Contacts",
  "customers.notes": "Notes",
  "customers.soon": "Coming soon",
  "customers.contactsBody": "Contacts are not stored yet.",
  "customers.notesBody": "Notes are not stored yet.",
  "customers.step.uploaded": "Uploaded",
  "customers.step.bom": "BOM",
  "customers.step.costed": "Costed",
  "customers.step.quoted": "Quoted",
  "customers.mark.costed": "Costed",
  "customers.mark.decided": "Decided",
  "customers.mark.unreadable": "Could not read file",
  "customers.mark.skipped": "Line skipped",
  "customers.mark.okLegend": "Costed or decided",
  "customers.mark.badLegend": "Unreadable or skipped",
  "customers.attention": "Needs attention",
  "customers.moreParts": "+{n}",
  "customers.event.received": "{no} received",
  "customers.event.sent": "Quote sent · {no}",
  "customers.event.won": "Won · {no}",
  "customers.event.lost": "Lost · {no}",
  "customers.event.outcome": "{status} · {no}",
  "customers.event.waiting": "Waiting on the customer · {no}",
  "customers.event.reply": "Customer reply · {no}",
  "customers.event.mailIn": "Mail in · {no}",
  "customers.event.mailOut": "Mail out · {no}",
  "customers.event.mail": "Mail · {no}",
  "customers.reason.price": "Price",
  "customers.reason.lead": "Lead time",
  "customers.reason.capacity": "Capacity",
  "customers.reason.no_bid": "No bid",
  "customers.source.catalog_part": "Catalog part",
  "customers.source.catalog_bom": "Catalog BOM",
  "customers.source.upload_job": "Upload",
  "customers.source.manual": "Entered",
  "customers.source.intake": "Intake",
  "customers.duration.min": "{n} min",
  "customers.duration.hour": "{n} h",
  "customers.duration.day1": "1 day",
  "customers.duration.days": "{n} days",
  "customers.kpi.customers": "Customers",
  "customers.kpi.openQuotes": "Open quotes",
  "customers.kpi.quotedTotal": "Quoted total",
  "customers.kpi.wonBefore": "Won before",
  "customers.export": "Export",
  "customers.bulk.one": "{n} customer selected",
  "customers.bulk.many": "{n} customers selected",
  "customers.bulk.export": "Export",
  "customers.bulk.merge": "Merge",
  "customers.bulk.clear": "Clear selection",
  "customers.menu.more": "More",
  "customers.menu.open": "Open customer",
  "customers.menu.rfqs": "Show RFQs",
  "customers.menu.quote": "New quote for customer",
  "customers.menu.merge": "Merge into…",
  "customers.mergeUnavailable": "Merging customers is not available yet.",
  "customers.emptyTitle": "No customers here yet",
  "customers.emptyBody": "Customers are created from the email on each RFQ.",
  "customers.noMatchTitle": "No customer matches “{query}”",
  "customers.noMatchHint": "Try a name, email or domain.",
  "customers.range": "{from}–{to} of {total}",
  "customers.select": "Select {name}",
  "customers.col.email": "Email",
  "customers.col.name": "Name",
  "customers.col.role": "Role",
  "customers.col.note": "Note",
  "stock.title": "Stock & Materials",
  "stock.sub": "On-hand stock. Open demand counts only RFQ lines that name a stock item.",
  "stock.search": "Search part, material or name",
  "stock.filters": "Filter materials",
  "stock.filter.all": "All",
  "stock.filter.in": "In stock",
  "stock.filter.short": "Short",
  "stock.filter.reserved": "Reserved",
  "stock.kpi.materials": "Materials",
  "stock.kpi.in": "In stock",
  "stock.kpi.short": "Short",
  "stock.kpi.demand": "Open demand",
  "stock.col.material": "Material",
  "stock.col.type": "Type",
  "stock.col.size": "Size",
  "stock.col.qty": "Qty",
  "stock.col.demand": "Demand",
  "stock.col.names": "Names",
  "stock.col.match": "Last RFQ",
  "stock.col.sizeHint": "Stored match dimensions",
  "stock.col.qtyHint": "Available quantity, or on hand when available is not stored",
  "stock.col.demandHint": "Quantity on open RFQs whose lines name this item",
  "stock.col.namesHint": "Saved requested names that point at this stock code",
  "stock.col.matchHint": "Newest RFQ whose line names this item",
  "stock.export": "Export",
  "stock.import": "Import CSV",
  "stock.add": "Add material",
  "stock.reimport": "Re-import",
  "stock.imported": "Last import {date}, {name}",
  "stock.notificationsEmpty": "Nothing is waiting on you.",
  "stock.bulk.one": "{n} material selected",
  "stock.bulk.many": "{n} materials selected",
  "stock.bulk.export": "Export",
  "stock.bulk.clear": "Clear selection",
  "stock.menu.more": "More",
  "stock.menu.copy": "Copy part number",
  "stock.menu.open": "Open RFQ",
  "stock.menu.link": "Link a requested name",
  "stock.menu.remove": "Remove {name}",
  "stock.copied": "Copied {part}",
  "stock.copyFailed": "Could not copy the part number.",
  "stock.select": "Select {name}",
  "stock.range": "{from}–{to} of {total}",
  "stock.emptyTitle": "No materials yet",
  "stock.emptyBody": "Add a material or import a CSV.",
  "stock.noMatchTitle": "Nothing matches “{query}”",
  "stock.noMatchHint": "Try a part number, material, or saved name.",
  "stock.noMatch": "No materials match this filter.",
  "stock.demand.none": "No open RFQs",
  "stock.demand.one": "{qty}{unit} · 1 RFQ",
  "stock.demand.many": "{qty}{unit} · {n} RFQs",
  "stock.demand.enough": "Enough",
  "stock.demand.short": "{n}{unit} short",
  "stock.belowMin": "{n}{unit} below minimum",
  "stock.reservedLine": "{n}{unit} reserved",
  "stock.unmatched": "{n} saved names do not match a stock code.",
  "stock.form.part": "Part number",
  "stock.form.description": "Description",
  "stock.form.material": "Material",
  "stock.form.unit": "Unit",
  "stock.form.qty": "Quantity",
  "stock.form.save": "Save",
  "stock.form.cancel": "Cancel",
  "stock.form.requested": "When this name is requested",
  "stock.form.useStock": "Use this stock",
  "stock.linked": "Saved name {name} for {code}.",
  "stock.removed": "Removed saved name {name}.",
  "stock.file": "CSV or Excel file",
  "subnav.collapse": "Collapse panel",
  "subnav.expand": "Expand panel",
  "subnav.hidePanel": "Hide panel",
  "subnav.showPanel": "Show panel",

  "drawings.title": "Parts and BOMs",
  "drawings.sub": "BOM materials and drawings for this organization",
  "drawings.col.id": "Job",
  "drawings.open": "Open",
  "drawings.actions": "Actions",
  "drawings.download": "Download",
  "drawings.downloadFailed": "Could not download file.",
  "drawings.delete": "Delete",
  "drawings.deleteTitle": "Delete drawing?",
  "drawings.deleteConfirm": "Delete this drawing job? This cannot be undone.",
  "drawings.deleteCancel": "Cancel",
  "drawings.deleteFailed": "Could not delete job.",
  "drawings.bomToggle": "Show BOM parts and stock match",
  "drawings.bomLoading": "Loading parts…",
  "drawings.bomEmpty": "No BOM parts yet",
  "drawings.bomLoadFailed": "Could not load BOM",
  "drawings.bomPartFallback": "Part {{n}}",
  "drawings.backToList": "All drawings",
  "drawings.dropTitle": "Drop to parse",
  "drawings.dropHint": "Release to upload and start production analysis",
  "drawings.dropBusy": "Parse already running",
  "drawings.dropBusyHint": "Wait for the current job to finish, then drop again",
  "drawings.dropUnsupported": "Use DXF, STEP, or DWG files.",
  "drawings.status.ready": "Ready",
  "drawings.status.parsing": "Parsing",
  "drawings.status.pending": "Pending",
  "drawings.status.partial": "Partial",
  "drawings.status.failed": "Failed",
  "drawings.status.review": "Needs review",
  "drawings.status.unknown": "—",
  "drawings.noPreview": "No preview",

  "home.greeting.morning": "Good morning, {name}!",
  "home.greeting.afternoon": "Good afternoon, {name}!",
  "home.greeting.evening": "Good evening, {name}!",
  "home.greeting.morningAnon": "Good morning!",
  "home.greeting.afternoonAnon": "Good afternoon!",
  "home.greeting.eveningAnon": "Good evening!",
  "home.kpi.parts": "Parts",
  "home.kpi.boms": "BOMs",
  "home.kpi.review": "Needs review",
  "home.kpi.orders": "Open orders",
  "home.actions": "Quick actions",
  "home.action.upload": "Upload drawing",
  "home.action.uploadHint": "Parse a STEP, DXF, or DWG file into a BOM.",
  "home.action.uploadCta": "Open file",
  "home.action.parts": "View parts",
  "home.action.partsHint": "Browse BOM materials across your drawings.",
  "home.action.partsCta": "View parts",
  "home.action.boms": "View BOMs",
  "home.action.bomsHint": "Open drawings and assemblies as BOMs.",
  "home.action.bomsCta": "View BOMs",
  "home.action.erp": "Open ERP",
  "home.action.erpHint": "Stock, purchase orders, and work orders.",
  "home.action.erpCta": "Open ERP",
  "home.data": "Quick data",
  "home.review.title": "Needs review",
  "home.review.empty": "No drawings waiting for review.",
  "home.review.view": "Open catalog",
  "home.activity.title": "Recent activity",
  "home.activity.empty": "Nothing here yet.",
  "home.activity.view": "Open ERP",

  "catalog.all": "All items",
  "catalog.parts": "Parts",
  "catalog.boms": "BOMs",
  "catalog.search": "Search",
  "catalog.searchPh": "Search parts and BOMs",
  "catalog.empty": "No items match this filter.",
  "catalog.partsLoading": "Loading parts…",
  "catalog.loading": "Loading catalog…",
  "catalog.cost": "Cost",
  "catalog.qty": "Quantity on hand",
  "catalog.description": "Description",
  "catalog.items": "Items",
  "catalog.usedIn": "Used in {n} BOMs",
  "catalog.folders": "Folders",
  "catalog.count": "{n}",
  "catalog.layout.aria": "Catalog layout",
  "catalog.layout.grid": "Grid",
  "catalog.layout.list": "List",
  "catalog.kind.part": "Part",
  "catalog.kind.bom": "BOM",

  "rfq.title": "RFQ estimates",
  "rfq.subtitle": "Decide how each part or BOM will be made and how long it will take",
  "rfq.new": "New RFQ",
  "rfq.newTitle": "Untitled RFQ",
  "rfq.search": "Search RFQ number or title…",
  "rfq.list.title": "RFQ",
  "rfq.list.search": "Search company, job or RFQ number",
  "rfq.list.newQuote": "New RFQ",
  "rfq.list.filters": "Filter by status",
  "rfq.list.filter.all": "All",
  "rfq.list.filter.bom": "Needs BOM review",
  "rfq.list.filter.cost": "Ready to cost",
  "rfq.list.filter.quoted": "Quoted",
  "rfq.list.filter.nocustomer": "No customer",
  "rfq.list.customerFilters": "Filter by customer",
  "rfq.list.assign": "Assign customer",
  "rfq.list.assignName": "Customer name",
  "rfq.list.assignEmail": "Email",
  "rfq.list.assignSave": "Assign",
  "rfq.list.assignEmpty": "No saved customers yet. Enter a name and email.",
  "rfq.list.assignHint": "The email is what lists this RFQ under Customers.",
  "rfq.list.col.number": "RFQ",
  "rfq.list.col.customer": "Customer",
  "rfq.list.col.email": "Email",
  "rfq.list.col.parts": "Parts",
  "rfq.list.col.status": "Status",
  "rfq.list.col.received": "Date received",
  "rfq.list.col.activity": "Last activity",
  "rfq.list.col.due": "Due",
  "rfq.list.col.quote": "Quote",
  "rfq.list.col.assignee": "Assignee",
  "rfq.list.assigneeLocked": "Assignee can't be saved. The engine has no assignee field on PATCH /v1/rfqs/{id} and no workspace members list.",
  "rfq.list.step.uploaded": "Uploaded",
  "rfq.list.step.bom": "BOM",
  "rfq.list.step.costed": "Costed",
  "rfq.list.step.quoted": "Quoted",
  "rfq.list.empty": "No RFQs yet.",
  "rfq.list.noMatch": "No RFQs match this filter.",
  "rfq.list.open": "Open RFQ",
  "rfq.list.pdf": "Quote PDF",
  "rfq.list.delete": "Delete",
  "rfq.list.selectAll": "Select all RFQs",
  "rfq.list.selectOne": "Select {no}",
  "rfq.list.bulkTitle": "Delete {count} RFQs?",
  "rfq.list.bulkTitleOne": "Delete 1 RFQ?",
  "rfq.list.bulkBody": "This cannot be undone.",
  "rfq.list.cancel": "Cancel",
  "rfq.list.deleting": "Deleting…",
  "rfq.list.actions": "Actions for {no}",
  "rfq.list.attention": "Needs attention",
  "rfq.list.sortNumber": "Sort by RFQ number",
  "rfq.list.sortReceived": "Sort by date received",
  "rfq.list.uploading": "Uploading",
  "rfq.list.uploaded": "Uploaded",
  "rfq.list.processing": "Processing",
  "rfq.list.confirmDelete": "Delete {no}?",
  "rfq.list.pdfDemo": "Quote PDF is not available in the demo.",
  "rfq.list.moreParts": "+{n}",
  "rfq.list.domainHint": "Email domain",
  "rfq.list.overdue": "Overdue",
  "rfq.list.mark.costed": "Costed",
  "rfq.list.mark.decided": "Decided",
  "rfq.list.mark.unreadable": "Could not read file",
  "rfq.list.mark.skipped": "Line skipped",
  "rfq.list.mark.okLegend": "Costed or decided",
  "rfq.list.mark.badLegend": "Unreadable or skipped",
  "rfq.list.tab.action": "Needs action",
  "rfq.list.tab.approval": "Awaiting approval",
  "rfq.list.tab.closed": "Closed",
  "rfq.list.filterButton": "Filter",
  "rfq.list.filter.date": "Date",
  "rfq.list.filter.last30": "Last 30 days",
  "rfq.list.filter.clear": "Clear",
  "rfq.list.filter.removeDate": "Remove date filter",
  "rfq.list.filtersMenu": "Filters",
  "rfq.list.col.job": "Job",
  "rfq.list.col.company": "Company",
  "rfq.list.col.stage": "Stage",
  "rfq.list.col.amount": "Amount",
  "rfq.list.col.uploadedBy": "Uploaded by",
  "rfq.list.col.updated": "Updated",
  "rfq.list.sortUpdated": "Sort by updated",
  "rfq.list.menu.documents": "Show documents",
  "rfq.list.menu.archive": "Archive",
  "rfq.list.archiveUnavailable": "Archive can't be saved. An RFQ has no archive field.",
  "rfq.list.export": "Export",
  "rfq.list.selected": "{count} RFQs selected",
  "rfq.list.selectedOne": "1 RFQ selected",
  "rfq.list.clearSelection": "Clear selection",
  "rfq.list.range": "{from}–{to} of {total}",
  "rfq.list.prev": "Previous",
  "rfq.list.next": "Next",
  "rfq.list.stage.stock": "Stock missing ({n} lines)",
  "rfq.list.stage.check": "Check needed",
  "rfq.list.stage.quoteReady": "Quote ready",
  "rfq.list.stage.parameters": "Parameters set",
  "rfq.list.updated.today": "Today",
  "rfq.list.updated.yesterday": "Yesterday",
  "rfq.list.updated.days": "{n} days",
  "rfq.list.preview.lastCost": "Last cost {amount}",
  "rfq.list.preview.usedIn": "Used in {n} RFQs",
  "rfq.list.preview.usedInOne": "Used in 1 RFQ",
  "rfq.list.preview.openDocs": "Open in Documents",
  "rfq.list.uploadedByMissing": "No uploader on this RFQ",
  "rfq.empty": "No RFQs yet. Create one, then add parts or BOMs from the catalog or a CAD upload.",
  "rfq.untitled": "Untitled",
  "rfq.col.no": "No",
  "rfq.col.title": "Title",
  "rfq.col.lines": "Lines",
  "rfq.col.hours": "Hours",
  "rfq.pendingShort": "{n} pending",
  "rfq.status.draft": "Draft",
  "rfq.status.estimating": "Estimating",
  "rfq.status.waiting": "Waiting for customer",
  "rfq.status.ready": "Ready",
  "rfq.status.sent": "Sent",
  "rfq.status.cancelled": "Cancelled",
  "rfq.status.won": "Won",
  "rfq.status.produced": "Produced",
  "rfq.status.lost": "Lost",
  "rfq.outcome.won": "Mark won",
  "rfq.outcome.lost": "Mark lost",
  "rfq.reason.label": "Loss reason",
  "rfq.reason.none": "No reason",
  "rfq.reason.price": "Price",
  "rfq.reason.lead": "Lead time",
  "rfq.reason.capacity": "Capacity",
  "rfq.reason.no_bid": "No bid",
  "rfq.winRate": "Win rate {pct}",
  "rfq.winRateEmpty": "Win rate —",
  "rfq.err.outcome": "Only a sent quote can be marked won or lost.",
  "rfq.send": "Mark sent",
  "rfq.sendMail": "Send quote mail",
  "rfq.sendQuestion": "Send question mail",
  "rfq.sendConfirm": "Send",
  "rfq.mailTo": "To",
  "rfq.convertOrder": "Convert to sales order",
  "rfq.linkedSo": "Sales order {so}",
  "rfq.sentAt": "Sent {when}",
  "rfq.pdf": "Download quote PDF",
  "rfq.quote.oneItem": "{n} item",
  "rfq.quote.manyItems": "{n} items",
  "rfq.err.margin": "Approve a margin before this quote can be sent.",
  "rfq.back": "All RFQs",
  "rfq.leadDays": "{n} d lead",
  "rfq.addCatalog": "From catalog",
  "rfq.pickLine": "Select a line to estimate routing and hours.",
  "rfq.makeBuyLabel": "Make or buy",
  "rfq.makeBuy.undecided": "Undecided",
  "rfq.makeBuy.make": "Make",
  "rfq.makeBuy.buy": "Buy",
  "rfq.makeBuy.outsource": "Outsource",
  "rfq.makeBuy.mixed": "Mixed",
  "rfq.buyKeepsRoute": "Buy does not replace mill ops — Freze hours stay on this line.",
  "rfq.outsourceKeepsRoute": "Outsource keeps the route as the subcontract estimate.",
  "rfq.supplier.title": "Supplier RFQ",
  "rfq.supplier.hint": "Last purchase: {price} · {days} d (not binding)",
  "rfq.supplier.hintPrice": "Last purchase: {price} (not binding)",
  "rfq.supplier.hintEmpty": "No last purchase on file",
  "rfq.supplier.waiting": "Waiting on supplier",
  "rfq.supplier.answered": "Supplier quoted",
  "rfq.supplier.unitPrice": "Unit price (TRY)",
  "rfq.supplier.lead": "Lead days",
  "rfq.supplier.reply": "Record supplier quote",
  "rfq.supplier.copy": "Copy supplier mail",
  "rfq.supplier.mailTitle": "Supplier mail (not sent)",
  "rfq.seedIntel": "Seed from production intel",
  "rfq.seedOverwriteTitle": "Replace operations?",
  "rfq.seedOverwriteBody": "This line already has operations. Overwrite them with production intel, merge missing ops, or re-run the estimate from geometry.",
  "rfq.seedOverwriteBtn": "Overwrite",
  "rfq.seedMergeBtn": "Merge",
  "rfq.seedRefreshBtn": "Refresh estimate",
  "rfq.cancel": "Cancel",
  "rfq.intel.meta": "{provider} · {pct}% confidence",
  "rfq.op": "Op",
  "rfq.setup": "Setup h",
  "rfq.run": "Run h/unit",
  "rfq.machine": "Machine",
  "rfq.addOp": "Add operation",
  "rfq.deleteLine": "Remove line",
  "rfq.noViewer": "This line has no CAD yet.",
  "rfq.viewerFailed": "Could not load the drawing.",
  "rfq.viewer.open": "Open in 3D",
  "rfq.viewer.close": "Close 3D viewer",
  "rfq.viewer.closeLabel": "Close",
  "rfq.viewer.panel": "3D viewer",
  "rfq.noDesc": "No description",
  "rfq.decision.pending": "Pending",
  "rfq.decision.decided": "Decided",
  "rfq.decision.skipped": "Skipped",
  "rfq.pickerTitle": "Add from catalog",
  "rfq.uploadFailed": "Upload did not return files.",
  "rfq.err.generic": "Could not update the RFQ.",
  "rfq.err.noIntel": "No production intel for this part. Parse the drawing first, or refresh the estimate.",
  "rfq.err.noJob": "This line has no source drawing.",
  "rfq.err.triage": "Quote is not ready. Missing or uncertain fields remain.",
  "rfq.err.audit": "Quote has internal contradictions.",
  "rfq.err.invalidQtys": "Those quantities are not valid.",
  "rfq.whatif": "Qty",
  "rfq.whatif.qty": "{n} pcs",
  "rfq.whatif.cost": "Cost",
  "rfq.whatif.lead": "Lead",
  "rfq.due": "Due date",
  "rfq.check": "Check quote",
  "rfq.triage.open": "Can we quote?",
  "rfq.triage.rerun": "Re-run check",
  "rfq.triage.loading": "Checking…",
  "rfq.triage.bannerTitle": "We can’t quote this RFQ yet",
  "rfq.triage.bannerBody": "Blocking points: {blockers}. Warnings: {warnings}.",
  "rfq.triage.bannerReady": "This RFQ can be quoted.",
  "rfq.triage.points": "Missing and risky points",
  "rfq.triage.foundBy": "Found by the quote check",
  "rfq.triage.blocking": "Blocking",
  "rfq.triage.risk": "Risk",
  "rfq.triage.added": "Added to email",
  "rfq.triage.questions": "Questions for the customer",
  "rfq.triage.draft": "Draft by agent",
  "rfq.triage.langTr": "Email language: Turkish",
  "rfq.triage.to": "To",
  "rfq.triage.subject": "Subject",
  "rfq.triage.copy": "Copy text",
  "rfq.triage.copied": "Copied",
  "rfq.triage.mailto": "Open in mail app",
  "rfq.triage.markSent": "Mark as sent → Waiting for customer",
  "rfq.triage.status": "RFQ status",
  "rfq.triage.waitingSince": "Waiting since {when}",
  "rfq.triage.waitingReply": "Waiting for reply",
  "rfq.triage.waitingNote": "Estimate is paused; nothing is sent to the customer automatically.",
  "rfq.triage.replies": "Saved replies",
  "rfq.triage.pasteTitle": "Paste the customer’s reply",
  "rfq.triage.pasteHelp": "Paste the email text. The reply is saved. Quantity, due date and material are filled only when the text states them, then the check runs again.",
  "rfq.triage.pastePh": "Paste reply here",
  "rfq.triage.apply": "Apply answers",
  "rfq.triage.attach": "Attach new drawing",
  "rfq.triage.applyNote": "When every blocking point is cleared, the status moves back to Estimating.",
  "rfq.triage.canWe": "Can we quote?",
  "rfq.triage.linesReady": "Lines ready to cost",
  "rfq.triage.linesReadyValue": "{ready} of {total}",
  "rfq.triage.blockingCount": "Blocking points",
  "rfq.triage.warningCount": "Warnings",
  "rfq.triage.items": "{n} items",
  "rfq.triage.item": "1 item",
  "rfq.triage.files": "{n} files",
  "rfq.triage.receivedToday": "received today {time}",
  "rfq.triage.received": "received {when}",
  "rfq.triage.unavailable": "The quote check is unavailable.",
  "rfq.triage.waitClear": "Nothing to wait on. The quote check is already clear.",
  "rfq.triage.quoteMail": "Quote email",
  "rfq.triage.empty": "No open points.",
  "rfq.markReady": "Mark ready",
  "rfq.wait": "Waiting on customer",
  "rfq.reply.label": "Customer reply",
  "rfq.reply.ph": "Paste the customer answer…",
  "rfq.reply.submit": "Record reply",
  "rfq.margin.suggested": "Suggested margin",
  "rfq.margin.approved": "Approved margin %",
  "rfq.margin.total": "Quote total",
  "rfq.copyMail": "Copy question mail",
  "rfq.copied": "Copied",
  "rfq.mailTitle": "Question mail (not sent)",
  "rfq.quoteReady": "Ready to quote",
  "rfq.quoteNotReady": "Not ready to quote",
  "rfq.findings": "Open questions",
  "rfq.auditTitle": "Quote check",
  "rfq.geo.uncertain": "Geometry methods disagree",
  "rfq.geo.winner": "Geometry: {source}",
  "rfq.geo.unread": "Unread drawing notes",
  "rfq.sub.title": "Material substitute",
  "rfq.sub.ask": "Needs customer OK",
  "rfq.sub.ok": "Same-grade substitute",
  "rfq.mailSubject": "Subject",
  "quote.locked": "Quote locked",
  "quote.download": "Download quote",
  "quote.hitl": "Quote · approve rows",
  "quote.partial": "Quote · missing file",
  "quote.parse": "Quote · parse required",
  "quote.geometry": "Quote · geometry uncertain",
  "quote.substitute": "Quote · substitute needs OK",
  "quote.noBid": "Quote · no bid",
  "rfq.similar": "{n} similar jobs, average {actual} h (then {est} h estimated)",
  "rfq.similarCost": "{actual} (then {est} estimated)",
  "rfq.similarEmpty": "No similar closed jobs yet",
  "rfq.similarOpen": "Open quote {no}",
  "rfq.similarHours": "{actual} actual · {est} estimated",
  "rfq.similarEstOnly": "{est} estimated",
  "rfq.similarActualOnly": "{actual} actual",
  "rfq.similarClosed": "Closed {when}",
  "rfq.similarWon": "Won close",
  "rfq.similarOver": "{h} over estimate",
  "rfq.similarUnder": "{h} under estimate",
  "rfq.similarOnEst": "on estimate",
  "rfq.err.intake": "Could not read the RFQ package.",
  "rfq.intake.title": "Mixed intake",
  "rfq.intake.hint": "Paste the email and drop CAD, Excel, or other attachments. Unread files stay attached, not parsed.",
  "rfq.intake.drop": "Drop CAD, Excel, PDF, or images",
  "rfq.intake.mail": "Email body",
  "rfq.intake.mailPh": "Paste the customer email…",
  "rfq.intake.submit": "Extract request",
  "rfq.intake.read": "Read",
  "rfq.intake.unread": "Unread",
  "rfq.intake.failed": "Failed",
  "rfq.intake.pending": "Pending",
  "rfq.intake.qtyUnknown": "qty unknown",
  "rfq.intake.remove": "Remove",
  "rfq.err.shortage": "Not enough stock to convert this quote.",
  "rfq.err.quoteLocked": "This quote is locked.",
  "rfq.err.useMailSend": "Send quote mail from the review dialog.",
  "rfq.quoteMailTitle": "Quote mail",
  "rfq.inbox": "Inbox",
  "rfq.inboxEmpty": "No inbound mail.",
  "rfq.inboxDisabled": "Mail receive is off.",
  "rfq.mailApply": "Apply to RFQ",
  "rfq.mailLink": "Link to this RFQ",
  "rfq.mailRead": "Mark read",
  "rfq.mailRetry": "Retry send",
  "rfq.supplier.send": "Send supplier mail",
  "rfq.supplier.email": "Supplier email",
  "rfq.deleteConfirmTitle": "Remove this line?",
  "rfq.deleteConfirmBody": "The line will be deleted from the quote.",

  "mail.delivery.queued": "Queued",
  "mail.delivery.sending": "Sending",
  "mail.delivery.sent": "Sent",
  "mail.delivery.failed": "Failed",
  "mail.delivery.unknown": "Unknown",
  "mail.unmatched": "Unmatched",
  "mail.matched": "Matched",

  "erp.title": "SemantiCAD ERP",
  "erp.subtitle": "Your workshop system of record — stock master, movements, POs, and work orders",
  "erp.refresh": "Refresh",
  "erp.nav.aria": "ERP sections",
  "erp.nav.overview": "Overview",
  "erp.nav.stock": "Stock",
  "erp.nav.movements": "Movements",
  "erp.nav.po": "Purchase",
  "erp.nav.wo": "Work orders",
  "erp.nav.so": "Sales orders",
  "erp.nav.dn": "Shipments",
  "erp.kpi.sku": "SKUs",
  "erp.kpi.critical": "Below min",
  "erp.kpi.openPo": "Open PO",
  "erp.kpi.openWo": "Open WO",
  "erp.kpi.movToday": "Moves today",
  "erp.activity": "Recent activity",
  "erp.activityEmpty": "No activity yet. Add stock or commit a job after review.",
  "erp.stockEmpty": "Stock master is empty. Add the first SKU or import a CSV.",
  "erp.cat.all": "All",
  "erp.cat.sabitler": "Fixed",
  "erp.cat.islenebilir": "Processable",
  "erp.cat.hurda_talas": "Scrap / swarf",
  "erp.cat.modullesmis": "Modular parts",
  "erp.col.category": "Category",
  "erp.col.itemClass": "Class / type",
  "erp.col.itemClassPh": "e.g. fastener, spare, billet…",
  "erp.stock.add": "Add stock",
  "erp.stock.addFirst": "Add first SKU",
  "erp.stock.importCsv": "Import CSV",
  "erp.stock.pull": "Pull external stock",
  "erp.stock.pullTitle": "External qty mismatches",
  "erp.stock.pullOk": "External stock matches local on-hand ({n} SKUs).",
  "erp.stock.pullConflicts": "{n} SKUs differ from external stock.",
  "erp.stock.search": "Search part, material, location…",
  "erp.stock.formCreate": "New stock item",
  "erp.stock.formEdit": "Edit stock item",
  "erp.stock.save": "Save",
  "erp.stock.edit": "Edit",
  "erp.stock.qtyHint": "Quantity changes use Adjust (receive / issue) so the ledger stays correct.",
  "erp.stock.created": "Stock created: {part}",
  "erp.stock.updated": "Stock updated: {part}",
  "erp.stock.imported": "Imported {n} stock rows (catalog replaced)",
  "erp.stock.noMatch": "No rows match the search.",
  "erp.stock.cadTitle": "CAD / file",
  "erp.stock.cadSabitHint": "For fixed parts, attach STEP geometry",
  "erp.stock.cadEmpty": "No file yet — PDF, image, or CAD (STEP/DXF)",
  "erp.stock.cadUpload": "Upload file",
  "erp.stock.cadDownload": "Download",
  "erp.stock.cadRemove": "Remove",
  "erp.stock.cadAfterSave": "Save the stock card first, then attach STEP/CAD.",
  "erp.stock.cadTypes": "Allowed: .step .stp .dxf .dwg .pdf .png .jpg .webp",
  "erp.stock.cadOk": "File attached: {name}",
  "erp.stock.cadCleared": "File removed from stock card",
  "erp.comp.title": "Bill of materials (contents)",
  "erp.comp.modulHint": "Sabitler + processable materials inside this modular part",
  "erp.comp.anyHint": "Optional: link child stock items to this parent",
  "erp.comp.emptyGroup": "None yet",
  "erp.comp.needQty": "Qty per module",
  "erp.comp.remove": "Remove",
  "erp.comp.other": "Other",
  "erp.comp.pickChild": "Select sabit / processable…",
  "erp.comp.add": "Add to module",
  "erp.comp.added": "Component added to modular BOM",
  "erp.comp.errChild": "Pick a child stock item",
  "erp.movEmpty": "No movements yet.",
  "erp.poEmpty": "No purchase orders. Create one manually, or commit a job with BUY actions after HITL.",
  "erp.woEmpty": "No work orders. Commit a job with MAKE actions after HITL.",
  "erp.soEmpty": "No sales orders. Convert a won RFQ to create one.",
  "erp.dnEmpty": "No delivery notes yet.",
  "erp.so.cancel": "Cancel order",
  "erp.dn.draft": "Create draft delivery note",
  "erp.dn.pdf": "PDF",
  "erp.dn.ship": "Ship and issue stock",
  "erp.dn.shipConfirm": "Confirm ship and issue stock",
  "erp.dn.cancel": "Cancel draft",
  "erp.dn.address": "Recipient address",
  "erp.dn.method": "Shipment method",
  "erp.dn.noOrders": "No eligible sales order to ship.",
  "erp.dn.review": "Review shipment",
  "erp.dn.lines": "Lines to issue",
  "erp.status.confirmed": "Confirmed",
  "erp.status.partial": "Partial",
  "erp.status.delivered": "Delivered",
  "erp.status.cancelled": "Cancelled",
  "erp.status.draft": "Draft",
  "erp.status.shipped": "Shipped",
  "erp.status.unknown": "Unknown",
  "erp.so.confirmCancel": "Cancel this sales order?",
  "erp.so.confirmCancelBody": "Active reservations will be released. Draft work orders and delivery notes will be cancelled.",
  "erp.dn.confirmCancel": "Cancel this draft delivery note?",
  "erp.dn.confirmCancelBody": "The draft will be discarded. Stock will not be issued.",
  "erp.err.salesDisabled": "Sales orders are not enabled for this workshop.",
  "erp.salesDisabled": "Sales orders are disabled.",
  "erp.confirm.continue": "Confirm",
  "erp.col.customer": "Customer",
  "erp.col.total": "Total ₺",
  "erp.col.part": "Part",
  "erp.col.desc": "Description",
  "erp.col.material": "Material",
  "erp.col.unit": "Unit",
  "erp.col.onHand": "On hand",
  "erp.col.externalQty": "External qty",
  "erp.col.delta": "Delta",
  "erp.col.reserved": "Reserved",
  "erp.col.available": "Available",
  "erp.col.min": "Min",
  "erp.col.max": "Max",
  "erp.col.price": "Price ₺",
  "erp.col.lead": "Lead days",
  "erp.col.location": "Location",
  "erp.col.supplier": "Supplier",
  "erp.col.kind": "Kind",
  "erp.col.qty": "Qty",
  "erp.col.balance": "Balance",
  "erp.col.ref": "Ref",
  "erp.col.actions": "Actions",
  "erp.col.docNo": "Document",
  "erp.col.status": "Status",
  "erp.col.lines": "Lines",
  "erp.adjust": "Adjust",
  "erp.adjustTitle": "Adjust #{id}",
  "erp.kind.receive": "Receive",
  "erp.kind.issue": "Issue",
  "erp.apply": "Apply",
  "erp.total": "Total",
  "erp.po.submit": "Submit",
  "erp.po.create": "New PO",
  "erp.po.formTitle": "New purchase order",
  "erp.po.hint": "Open a manual PO for purchases not tied to a drawing.",
  "erp.po.addLine": "Add line",
  "erp.po.removeLine": "Remove line",
  "erp.po.notes": "Notes",
  "erp.po.save": "Save",
  "erp.po.created": "{no} created.",
  "erp.po.errLines": "At least one line needs a part no and a quantity above zero.",
  "erp.po.receive": "Receive",
  "erp.wo.release": "Release",
  "erp.wo.complete": "Complete",

  // ERP v2-1 — shop-floor terminal, machines, estimate accuracy
  "erp.nav.terminal": "Hours entry",
  "erp.nav.machines": "Machines",
  "erp.nav.accuracy": "Estimate accuracy",
  "erp.sf.disabled": "Shop-floor tracking is off. Enable it on the engine:",
  "erp.sf.noWo": "No open work orders. Create one first.",
  "erp.sf.noOps": "This work order has no operations. Define a route.",
  "erp.sf.good": "Good",
  "erp.sf.scrap": "Scrap",
  "erp.sf.est": "Estimated",
  "erp.sf.recorded": "Recorded",
  "erp.sf.hoursLabel": "Duration (hours)",
  "erp.sf.save": "Save",
  "erp.sf.addMore": "Add time",
  "erp.sf.entrySaved": "Time recorded.",
  "erp.sf.errHours": "Duration must be greater than zero.",
  "erp.sf.noMachine": "No machine assigned",
  "erp.sf.status.pending": "Pending",
  "erp.sf.status.running": "Running",
  "erp.sf.status.done": "Done",
  "erp.sf.status.skipped": "Skipped",
  "erp.sf.cost.material": "Material",
  "erp.sf.cost.labor": "Labour",
  "erp.sf.cost.total": "Total",
  "erp.sf.cost.perUnit": "Per good unit",
  "erp.sf.cost.hoursVar": "Hours variance",
  "erp.sf.cost.scrapRate": "Scrap rate",
  "erp.sf.close": "Close work order",
  "erp.sf.closed": "Work order closed, real cost recorded.",
  "erp.machines.hint": "The hourly rate is what turns clocked hours into money.",
  "erp.machines.add": "Add machine",
  "erp.machines.empty": "No machines yet. Add at least one to get real cost.",
  "erp.machines.code": "Code",
  "erp.machines.name": "Name",
  "erp.machines.kind": "Kind",
  "erp.machines.rate": "Hourly rate",
  "erp.machines.capacity": "Daily capacity",
  "erp.machines.save": "Save",
  "erp.machines.noRate": "no rate set",
  "erp.machines.errCode": "Machine code is required.",
  "erp.machines.created": "{code} added.",
  "erp.acc.hint":
    "Compares estimated against actual hours on finished operations. A ratio above 1 means we keep under-quoting that process.",
  "erp.acc.empty": "No finished operations yet. This fills up as work is clocked in the terminal.",
  "erp.acc.opCode": "Process",
  "erp.acc.count": "Operations",
  "erp.acc.est": "Estimated",
  "erp.acc.actual": "Actual",
  "erp.acc.variance": "Variance",
  "erp.acc.ratio": "Ratio",
  "erp.acc.scrapRate": "Scrap",
  "erp.acc.underQuoted": "under-quoted",
  "erp.acc.overQuoted": "over-quoted",
  "erp.err.db": "ERP needs Postgres (DATABASE_URL). Start local stack and migrate.",
  "erp.err.disabled": "ERP is disabled on the engine (SEMANTICAD_ERP_V1).",
  "erp.err.pullNotConfigured":
    "External ERP pull is not configured. Set SEMANTICAD_ERP_PULL_URL, or SEMANTICAD_ERP_PULL_ADAPTER=sim.",
  "erp.err.pullFailed": "External ERP pull failed.",
  "erp.err.generic": "ERP request failed",
  "erp.err.qty": "Enter a positive quantity",
  "erp.err.partRequired": "Part number is required",
  "erp.commit": "Post to ERP",
  "erp.commitBusy": "Posting…",
  "erp.commitOk": "ERP documents created",
  "erp.commitBlocked": "Approve HITL before posting to ERP",

  "status.online": "Connected",
  "status.offline": "Disconnected",
  "status.queue": "Queue: {count}",
  "status.language": "Language",
  "status.lang.en": "English",
  "status.lang.tr": "Türkçe",

  "welcome.subtitle": "Open a CAD file and start production analysis",
  "welcome.dashboardSub": "Workshop overview — past jobs, totals, and open a new file",
  "welcome.dropLabel": "Drag a file or browse",
  "welcome.formats": "DXF · STEP · DWG",
  "welcome.openFile": "Open File",
  "welcome.loadDemo": "Load demo assembly",
  "welcome.loadingDemo": "Loading demo assembly…",
  "welcome.demoHint": "SLICRANK MECHANISM — offline BOM + report + mesh",
  "welcome.recent": "Recent drawings",
  "welcome.history": "Job history",
  "welcome.historyLoading": "Loading history…",
  "welcome.historyEmpty": "No jobs yet. Open a CAD file or load the demo to get started.",
  "welcome.historyError": "Could not load server history. Showing local cache if any.",
  "welcome.refresh": "Refresh",
  "welcome.newWork": "New work",
  "welcome.openHint": "DXF, STEP or DWG. Multi-file packs ask for a master assembly.",
  "welcome.kpiAria": "Workshop KPIs",
  "welcome.kpi.jobs": "Jobs",
  "welcome.kpi.jobsHint": "total in history",
  "welcome.kpi.ready": "Ready",
  "welcome.kpi.readyHint": "parse complete",
  "welcome.kpi.open": "In progress",
  "welcome.kpi.openHint": "parsing / review",
  "welcome.kpi.parts": "Parts",
  "welcome.kpi.partsHint": "BOM lines seen",
  "welcome.kpi.material": "Material ₺",
  "welcome.kpi.materialHint": "session estimates",
  "welcome.col.file": "File",
  "welcome.col.status": "Status",
  "welcome.col.parts": "Parts",
  "welcome.col.when": "Updated",

  "tab.viewer": "View",
  "tab.bom": "BOM",
  "tab.reports": "Production Report",
  "tab.viewerShort": "Viewer",
  "tab.viewerOpen": "Show 3D/2D viewer beside work",
  "tab.viewerClose": "Hide viewer",
  "tab.reportsShort": "Reports",
  "tab.review": "Review",

  "mode.parts": "Parts",
  "mode.review": "Review",
  "mode.quote": "Quote",
  "mode.preview": "Preview",
  "mode.previewHint": "reference only",
  "split.resize": "Resize preview and work panels",
  "mode.aria": "Work steps",
  "mode.jobSteps": "Job steps: Parts, Review, Quote",
  "mode.geometry": "Parts",
  "mode.production": "Quote",

  "parse.queued": "Queued…",
  "parse.processing": "Processing…",
  "parse.analyzing": "Analyzing…",
  "parse.loadingHistory": "Loading previous drawing…",
  "parse.error": "Parse error",
  "parse.pack": "Parsing work package…",
  "parse.packMaster": "Work package: parsing master… (+{n} satellites)",
  "parse.retry": "Re-parsing…",
  "parse.quotePreparing": "Preparing quote PDF…",
  "parse.partialFailed":
    "Partial parse: {n} satellite file(s) failed. Quote unlocks after approve/fix.",
  "parse.softCap": "Many solids ({n}) — list simplified",
  "parse.quoteReady": "Quote generated:\n{detail}",
  "parse.drawingPreparing": "Preparing production drawing PDF…",
  "parse.drawingReady": "Production drawing ready:\n{detail}",

  "drawing.assembly": "Assembly drawing",
  "drawing.assemblyHint": "Multi-view PDF of the whole model (shape + data, not a quote)",
  "drawing.part": "Part drawing",
  "drawing.partCol": "Drawing",
  "drawing.partHint": "Multi-view PDF for this BOM solid only",
  "drawing.exporting": "Drawing…",
  "drawing.started": "Production drawing download started…",
  "drawing.ok": "Production drawing downloaded",
  "drawing.fail": "Drawing export failed",

  "tabbar.empty": "Open a file or drop STEP/DXF",
  "tabbar.close": "Close tab",
  "tabbar.openBom": "BOM",
  "tabbar.openReport": "Report",
  "tabbar.openReview": "Review",

  "hitl.banner.blocked": "Quote locked · {count} open",
  "hitl.banner.ready": "Quote unlocked",
  "hitl.banner.noJob": "Open or parse a job to review HITL",
  "hitl.approve": "Approve",
  "hitl.approveAll": "Approve all",
  "hitl.empty": "No rows waiting for review",
  "hitl.openCount": "{count} open",
  "hitl.reasons.low_confidence": "Low confidence",
  "hitl.detail.reasons": "Reasons",
  "hitl.detail.confidence": "Confidence",
  "hitl.detail.none": "Select a row",
  "hitl.detail.material": "Material",
  "hitl.detail.qty": "Qty",
  "hitl.detail.reason": "Reason",
  "hitl.reasonPlaceholder": "Why reject or no-bid?",
  "hitl.reject": "Reject",
  "hitl.noBid": "No bid",
  "hitl.reasonRequired": "Reason required",
  "hitl.invalidQty": "Qty must be greater than 0",
  "hitl.lowConf.title": "Low-confidence measures",
  "report.kpi.meta.volumeHoles": "{vol} · {n} holes",
  "report.kpi.meta.volumeOcc": "solid volume",
  "report.kpi.meta.volumeProxy": "proxy volume",
  "report.kpi.meta.holesOnly": "{n} holes",

  "panel.explorer": "Explorer",
  "panel.select": "Select",
  "panel.measure": "Measure",
  "panel.bom": "BOM",
  "panel.reports": "Reports",
  "panel.selectPart": "Select / highlight part",
  "panel.days": "{n} days",
  "panel.openTabs": "Open tabs",
  "panel.drawings": "Drawings",
  "panel.noDrawings": "No open drawings",
  "panel.openDrawingFirst": "Open a drawing first.",
  "panel.noSelection": "No selection",
  "panel.coord": "coordinate",
  "panel.noActiveDrawing": "No active drawing.",
  "panel.noBom": "No BOM data.",
  "panel.openBomTab": "Open BOM tab",
  "panel.fullBom": "Full BOM view",
  "panel.itemCount": "{n} items",
  "panel.production": "Production",
  "panel.material": "Material",
  "panel.lead": "Lead",
  "panel.fullReport": "Full report view",
  "panel.parts": "Parts",
  "panel.noParts": "No parts",
  "panel.measures": "Dimensions",
  "panel.stock": "Stock",
  "panel.profile": "Profile",

  "report.kpi.labor": "Labor",
  "report.kpi.meta.totalEst": "total estimate",
  "report.kpi.meta.items": "{n} items",
  "report.kpi.meta.raw": "raw material",
  "report.kpi.meta.machining": "mill / turn / drill",
  "report.kpi.meta.setup": "setup + assembly",
  "report.kpi.meta.daysUnit": "days",
  "report.kpi.meta.assemblyDays": "assembly ~{n}d",
  "report.kpi.meta.leadEst": "delivery estimate",
  "report.kpi.meta.riskSummary": "risk summary",
  "report.kpi.risk.critical": "{n} red",
  "report.kpi.risk.yellow": "{n} yellow",
  "report.kpi.risk.green": "all green",
  "report.kpi.goDetail": "Open {title} detail",
  "report.hero.fallbackLead":
    "Estimated lead for this job is about {n} working days. Open the route for the full plan.",
  "report.hero.fallbackEmpty":
    "Production metrics will appear here once the engine finishes the forecast.",
  "report.price.erpTitle": "Price from ERP stock unit price",
  "report.price.staleMark": " — FX STALE",
  "report.price.fxSell": "× {source} sell {rate} ({date})",

  "props.title": "Properties",
  "props.tabsAria": "Property tabs",
  "props.tab.part": "Part",
  "props.tab.drawing": "Drawing",
  "props.tab.selection": "Selection",
  "props.partCode": "part number",
  "props.part": "part",
  "props.partN": "Part {n}",
  "props.itemNo": "item no",
  "props.solid": "solid",
  "props.solidIndex": "solid index",
  "props.point": "point (mm)",
  "props.faceIndex": "face #",
  "props.class": "class",
  "props.source": "source",
  "props.rawData": "Raw data",
  "props.partNo": "part no",
  "props.description": "description",
  "props.qty": "qty",
  "props.material": "material",
  "props.unit": "unit",
  "props.confidence": "confidence",
  "props.risk": "risk",
  "props.suggestion": "suggestion",
  "props.shortage": "shortage",
  "props.materialTry": "material ₺",
  "props.stockMatch": "Stock match",
  "props.stockName": "stock name",
  "props.stockCode": "stock code",
  "props.stockQty": "stock qty",
  "props.score": "score",
  "props.match": "match",
  "props.stockMaterial": "stock material",
  "props.unitPrice": "unit ₺",
  "props.engineMeta": "Engine meta",
  "props.rawBom": "Raw BOM",
  "props.drawingDims": "drawing dimensions",
  "props.production": "production",
  "props.lead": "lead",
  "props.leadDays": "{n} days",
  "props.unitsReady": "units ready",
  "props.volume": "volume",
  "props.materialCost": "Material cost",
  "props.noSelection": "No selection",
  "props.empty": "Select a part or point",
  "props.noPart": "No part selected. Click a part in the viewer.",
  "props.noBomMatch": "No BOM row matched this solid.",
  "props.pickHint": "Select a face in the viewer. Point / face data appears here.",
  "props.noActiveDrawing": "No active drawing.",

  "bom.error": "Parse error occurred.",
  "bom.retry": "Retry",
  "bom.refresh": "Refresh",
  "bom.empty": "No BOM items.",
  "bom.title": "BOM · {name}",
  "bom.noStock": "No stock",
  "bom.material": "Material: {n} ₺",
  "bom.save": "Save",
  "bom.sortHint": "Order: risk · shortage · part",
  "bom.filterEmpty": "No rows for this filter.",
  "bom.col.partNo": "Part No",
  "bom.col.qty": "Qty",
  "bom.col.stock": "Stock",
  "bom.col.match": "Match",
  "bom.col.stockCode": "Stock Code",
  "bom.col.risk": "Risk",
  "bom.col.shortage": "Shortage",
  "bom.col.material": "Material",
  "bom.col.desc": "Description",
  "bom.col.action": "Action",

  "stockFilter.aria": "Stock match filter",
  "stockFilter.all": "All",
  "stockFilter.dimension": "Dimension",
  "stockFilter.exact": "Exact",
  "stockFilter.fuzzy": "Fuzzy",
  "stockFilter.other": "Other",
  "stockFilter.none": "No match",

  "stockPicker.close": "Close",
  "stockPicker.pick": "Pick stock",
  "stockPicker.candidates": "Candidates ({n})",
  "stockPicker.none": "No candidates",
  "stockPicker.failed": "Error: {msg}",

  "measure.count": "{n} dimensions",
  "measure.countPreview": "{n} dimensions (preview)",
  "measure.countDxf": "{n} dimensions (DXF)",
  "measure.none": "No dimensions",
  "measure.openList": "Open dimension list",
  "measure.title": "DIMENSIONS",
  "measure.preview": "preview",

  "viewer.fit": "Fit",
  "viewer.fitTitle": "Fit model to view",
  "viewer.front": "Front",
  "viewer.frontTitle": "Front view",
  "viewer.top": "Top",
  "viewer.topTitle": "Top view",
  "viewer.right": "Right",
  "viewer.rightTitle": "Right view",
  "viewer.iso": "Iso",
  "viewer.isoTitle": "Isometric view",
  "viewer.wire": "Wire",
  "viewer.wireTitle": "Toggle wireframe",
  "viewer.measure": "Measure",
  "viewer.measureTitle": "Two-point measure mode",
  "viewer.isolate": "Isolate",
  "viewer.isolateTitle": "Show selected part only",
  "viewer.empty": "No drawing open yet. Open a DXF/STEP/DWG file (Ctrl+O).",
  "viewer.partPickerAria": "Assembly parts",
  "viewer.dxfNeedParse": "DWG 2D preview needs the engine to parse the file.",
  "viewer.no2d": "No 2D geometry found.",
  "viewer.reopenHint":
    "Re-open the file (engine must be running). DWG needs ODA File Converter installed.",
  "viewer.stepLoadFail": "Could not load 3D model.",
  "viewer.partFallback": "Part {n}",
  "viewer.pickCandidate": "Pick from candidates",
  "viewer.partLabel": "Part",
  "viewer.isolated": "isolated",
  "viewer.highlight": "highlight",
  "viewer.hover": "hover",
  "viewer.loadFile": "Load a file or select a drawing",
  "viewer.loading3d": "Loading 3D model…",
  "viewer.setupHint":
    "For setup run scripts/setup-conda-engine and start the project with the local start script.",

  "nav.account": "Account",
  "nav.proLicense": "Pro Workshop License",
  "nav.profile": "Profile settings",
  "nav.billing": "License & billing",
  "nav.billingSoon": "Billing is not available yet",
  "nav.themeLight": "Light mode",
  "nav.themeDark": "Dark mode",
  "nav.logout": "Sign out",
  "nav.logoutFailed": "Sign out failed",
  "nav.context": "Context",
  "nav.holes": "{n} holes",

  "profile.identity": "Identity",
  "profile.refresh": "Refresh",
  "profile.loading": "Loading profile…",
  "profile.loadFailed": "Could not load profile",
  "profile.name": "Display name",
  "profile.email": "Email",
  "profile.organization": "Organization",
  "profile.orgSlug": "Organization ID",
  "profile.role": "Role",
  "profile.writeAccess": "Write access",
  "profile.canWrite.yes": "Yes",
  "profile.canWrite.no": "No (viewer)",
  "profile.authVia": "Signed in via",
  "profile.role.owner": "Owner",
  "profile.role.member": "Member",
  "profile.role.viewer": "Viewer",
  "profile.role.service": "Service key",
  "profile.role.unknown": "—",
  "profile.section.account": "Account",
  "profile.section.accountHint": "How you appear to your workshop. Email cannot be changed here.",
  "profile.section.org": "Organization",
  "profile.section.orgHint": "Workshop membership for this session. Contact an owner to change roles.",
  "profile.section.security": "Security",
  "profile.section.securityHint": "Update your password. You will stay signed in on this device.",
  "profile.emailReadonly": "Email is managed by your organization admin.",
  "profile.save": "Save changes",
  "profile.saving": "Saving…",
  "profile.saved": "Profile updated",
  "profile.needSession": "Sign in with email and password to edit this.",
  "profile.currentPassword": "Current password",
  "profile.newPassword": "New password",
  "profile.confirmPassword": "Confirm new password",
  "profile.passwordRules": "Use at least 8 characters.",
  "profile.passwordTooShort": "New password must be at least 8 characters.",
  "profile.passwordMismatch": "New password and confirmation do not match.",
  "profile.changePassword": "Update password",
  "profile.changingPassword": "Updating…",
  "profile.passwordChanged": "Password updated successfully",

  "stock.catalog": "Catalog",
  "stock.refresh": "Refresh",
  "stock.loading": "Loading stock…",
  "stock.loadFailed": "Could not load stock catalog",
  "stock.itemCount": "Items",
  "stock.source": "Source",
  "stock.org": "Organization",
  "stock.importHint": "Import a CSV with Stok Kodu / part_no columns. Replaces the org catalog.",
  "stock.importCsv": "Import CSV",
  "stock.importing": "Importing…",
  "stock.importOk": "Imported {n} items",

  "stock.section": "section {n}mm",
  "stock.box": "box {w}×{t}mm",
  "stock.envelope": "envelope {w}×{h}mm",
  "stock.cut": "cut {n}mm",
  "stock.drawing": "Drawing: {dims}",

  "chat.title": "Production Assistant",
  "chat.trace": "Trace",
  "chat.comprehensive": "Deep analysis",
  "chat.send": "Send",
  "chat.placeholder": "Ask about holes, cost, stock, production…",
  "chat.role.you": "You",
  "chat.quick.volume": "Volume",
  "chat.quick.volumePrompt": "What is the volume?",
  "chat.quick.holes": "Hole summary",
  "chat.quick.cost": "Cost estimate?",
  "chat.quick.stock": "Stock risk?",
  "chat.quick.route": "Production route?",
  "chat.quick.selection": "Summary for this selection",
  "chat.noReply": "No reply received.",
  "chat.drawingFallback": "drawing",
  "chat.hello":
    "Hello — «{name}» is open. Ask about volume, holes, cost, stock, or production.",
  "chat.shortPrompt": "Say briefly what you need (holes, cost, stock, production…).",
  "chat.volumeValue": "Volume ≈ {v} m³.",
  "chat.volumeNone": "No volume data.",
  "chat.holesDetail": "{n} holes — {parts}.",
  "chat.holesFound": "~{n} holes detected.",
  "chat.holesLimited": "Hole data is limited.",
  "chat.engineDown":
    "Cannot reach the engine. Ask about holes, cost, stock, or production — details unlock when connected.",
  "chat.agent.geometry": "Geometry specialist",
  "chat.agent.cost": "Cost specialist",
  "chat.agent.risk": "Risk specialist",
  "chat.systemPrompt":
    "Answer like a workshop engineer. Summarize holes by diameter groups (Ø×count); do not dump 50+ raw lines. " +
    "For make/buy use MAKE_INTERNAL vs BUY, critical path, and concrete next steps. " +
    "On greetings/noise do not print a full menu or report. Prioritize selection when present.",

  "trace.drawingSummary": "Drawing summary",
  "trace.geometryDetail": "Geometry detail",
  "trace.productionIntel": "Production intel",
  "trace.workshopSolutions": "Workshop solutions",
  "trace.stockRisk": "Stock risk",
  "trace.partDetail": "Part detail",
  "trace.searchStock": "Stock search",
  "trace.route": "Routing",
  "trace.plan": "Plan",
  "trace.reasoning": "Reasoning",
  "trace.tools": "Tool selection",
  "trace.prefetch": "Data load",
  "trace.agents": "Specialists",
  "trace.synthesize": "Synthesis",
  "trace.answer": "Answer",
  "trace.skipped": "Skipped",
  "trace.chainTitle": "Thought chain",
  "trace.toolsTitle": "Tool selection",
  "trace.running": "Running",
  "trace.done": "Done",
  "trace.ok": "OK",
  "trace.charsReport": "{n} char report",
  "trace.subAgents": "Sub-agent analysis",
  "trace.hideParams": "Hide parameters",
  "trace.params": "Parameters",

  "error.detailsLog": "Details were written to browser console.",
  "dev.file": "File: {path}",

  "report.nav.overview": "Overview",
  "report.nav.cost": "Cost detail",
  "report.nav.material": "Material prices",
  "report.nav.lead": "Lead time",
  "report.nav.route": "Production route",
  "report.nav.part": "Part plan",
  "report.nav.parts": "Part plans",
  "report.nav.dfm": "DFM analysis",
  "report.sectionsAria": "Report sections",
  "report.breadcrumbAria": "Report location",
  "report.back": "Back",
  "report.crumbRoot": "Production report",
  "report.exportOk": "Report exported (JSON · Excel · PDF).",
  "report.exportFail": "Export failed",
  "report.export": "Export",
  "report.title": "PRODUCTION REPORT",
  "report.assistant": "Production assistant",
  "report.error": "Failed to load report.",
  "report.detail": "Detail →",
  "report.refreshData": "Refresh data",
  "report.exporting": "Exporting…",
  "report.exportTitle": "Export JSON, Excel and PDF reports",
  "report.exportTitleShort": "JSON, Excel, PDF",
  "report.noIntel": "No production data yet.",
  "report.noMaterialPricing":
    "No material price rows for this drawing yet. Open a job with catalog/FX data, or refresh after parse.",
  "report.sidebar.summary": "Job summary",
  "report.ai.empty": "No AI recommendations yet for this drawing.",
  "report.ai.run": "Analyze with AI",
  "report.noPartPlan": "Part plan not found.",
  "report.backToParts": "Back to all parts",
  "report.rev": "Rev",
  "report.kpi.productionCost": "Production Cost",
  "report.kpi.material": "Material",
  "report.kpi.machining": "Machining",
  "report.kpi.leadTime": "Lead Time",
  "report.kpi.stockRisk": "Stock / Risk",
  "report.kpi.dfm": "DFM score",
  "report.scheduleAria": "Production schedule",
  "report.legendAria": "Legend",
  "report.costJourneyAria": "Cost journey",
  "report.days": "{n} days",
  "report.stockQtyTitle": "Stock quantity",
  "report.partPlansTitle": "Part-level production plan",
  "report.assemblyTitle": "Assembly plan",
  "report.materialTitle": "Live material prices",
  "report.fxTitle": "Live FX",
  "report.fxStale": "FX rate is stale",
  "report.fxStaleDetail": "FX is stale — using last known rate from {date}.",
  "report.fxMeta": "FX: {source} sell {pair} {rate} · {date}",
  "report.moreClasses": " · +{n} classes",
  "report.col.material": "Material",
  "report.col.usdKg": "USD/kg base",
  "report.col.tryKg": "TRY/kg",
  "report.col.part": "Part",
  "report.col.desc": "Description",
  "report.col.qty": "Qty",
  "report.col.unitPrice": "Unit price",
  "report.col.source": "Source",
  "report.col.line": "Line",
  "report.col.match": "Match",
  "report.col.stockCode": "Stock code",
  "report.op.turning": "Turning",
  "report.op.drilling": "Drilling",
  "report.op.cutting": "Cutting",
  "report.op.milling": "Milling",
  "report.op.welding": "Welding",
  "report.op.setup": "Setup",
  "report.opCostTitle": "Operation cost estimate",
  "report.total": "Total",
  "report.labor": "Labor",
  "report.moreItems": "+{n} more items",
  "report.costNeedsIntel": "production_intel is required for cost data.",
  "report.price.erp": "ERP stock",
  "report.price.market": "Live FX",
  "report.price.default": "Default",
  "report.price.unknown": "Unknown",
  "report.price.defaultTitle": "No FX/stock data — default steel price used",
  "report.feedback.title": "Actual outcome",
  "report.feedback.save": "Save",
  "report.feedback.fail": "Save failed",
  "report.feedback.ok": "Saved",
  "report.feedback.actualCost": "Actual cost (₺)",
  "report.feedback.actualLead": "Actual lead (days)",
  "report.feedback.predicted": "Predicted",
  "report.feedback.costLabel": "Cost (₺)",
  "report.feedback.leadLabel": "Lead (days)",
  "report.routeTitle": "Production route",
  "report.routePrompt":
    "Explain the production route like a workshop assistant. Write 3–6 sentences for the planner/customer; " +
    "cover critical path, which parts can run in parallel, lead time and machine hints. " +
    "Do not dump a raw MAKE_INTERNAL list. End with 1-2-3 actions.",
  "report.routeAgent":
    "Production route assistant: use workshop_solutions and production_intel. " +
    "Human, clear, actionable. No coordinate/hole dumps.",
  "report.route.tell": "Explain with assistant",
  "report.route.retell": "Explain again",
  "report.route.telling": "Explaining…",
  "report.route.tellTitle": "LLM workshop-assistant narration",
  "report.route.emptyLlm": "Assistant reply empty — check LLM key or parse data.",
  "report.route.fail": "Assistant request failed",
  "report.route.steps": "Part / action steps",
  "report.route.notReady":
    "Production route not ready yet — send the drawing to the engine to build the route.",
  "report.route.leadChip": "Lead ~{n} days",
  "report.route.openLead": "Production route detail →",
  "report.lead.total": "Total lead",
  "report.lead.materialWait": "Material wait",
  "report.lead.assembly": "Assembly",
  "report.lead.steps": "Work steps",
  "report.lead.noSchedule": "No schedule steps — lead is total days only.",
  "report.lead.machine": "Machining",
  "report.lead.wait": "Wait",
  "report.lead.criticalPart": "Critical-path part",
  "report.part.duration": "Duration",
  "report.part.stock": "Stock",
  "report.part.position": "Assembly position (mm)",
  "report.part.hours": "{n} h",
  "report.schedule.moreSteps": "+{n} more steps",
  "report.route.moreSteps": "+{n} steps — open detail",
  "report.route.planBadge": "plan summary",
  "report.route.looking": "Reviewing route data…",
  "report.route.schedule": "Schedule",
  "report.revision.title": "Revision",
  "report.revision.plan": "Plan",
  "report.ai.title": "AI recommendations",
  "report.ai.priorityActions": "Priority actions",
  "report.ai.blockers": "Blockers",
  "report.ai.alternatives": "Alternatives",
  "report.dfm.title": "DFM analysis",
  "report.dfm.counts": "{critical} critical · {warning} warnings",
  "report.dfm.noIssues": "No structured DFM warnings.",
  "report.part.cost": "Cost",
  "report.part.ops": "Operation sequence",
  "report.part.noOps": "No operations listed.",
  "report.part.leadHint": "Estimated lead for this part: {n} days",
  "report.part.count": "{n} parts",
  "report.part.all": "All →",
  "report.part.critical": "critical path",
  "report.part.solidRef": "3D solid reference",
  "report.part.llmRefined": "Operations refined by LLM",
  "report.type.govde": "Body",
  "report.type.large": "Large component",
  "report.type.medium": "Medium component",
  "report.type.component": "Component",
  "report.type.small": "Small component",
  "report.type.fastener": "Fastener",
  "report.dfm.scoreTitle": "Manufacturability score",
  "report.dfm.costDrivers": "Cost drivers",
  "report.stock.noCritical": "No critical stock risk.",
  "report.schedule.waitDays": "{n} days wait",
  "report.schedule.dayRange": "day {start}–{end}",
  "report.schedule.day0": "day 0",
  "report.schedule.dayN": "day {n}",
  "report.revision.deltaDays": "{n} days",
  "report.revision.lead": "Lead",
  "report.revision.schedule": "Schedule",
  "report.ai.error": "Agent error",
  "report.ai.refresh": "Refresh",
  "report.schedule.cut": "Cut",
  "report.schedule.turn": "Turn",
  "report.schedule.drill": "Drill",
  "report.schedule.mill": "Mill",
  "report.schedule.weld": "Weld",
  "report.schedule.assembly": "Assembly",
  "report.schedule.inspect": "Inspect",
  "report.schedule.paint": "Paint",
  "report.schedule.ship": "Ship",

  "op.DELIK": "Drilling",
  "op.TORNA": "Turning",
  "op.FREZE": "Milling",
  "op.KESIM": "Cutting",
  "op.KAYNAK": "Welding",
  "op.MONTAJ": "Assembly",
  "op.TASLAMA": "Grinding",
  "op.TEMIN": "Buy / purchase",
  "op.BOYA": "Paint",
  "op.KONTROL": "Inspection",
  "op.SETUP": "Setup",

  "dev.hide": "Hide",
  "dev.show": "Show",
  "dev.logs": "Dev logs",
  "dev.trace": "Trace",

  "cache.refresh": "Refresh",
  "cache.refreshTitle": "Refresh data",
  "cache.stale": "Incomplete data",
  "cache.staleTitle": "Parse data incomplete",

  "report.sidebar.scenario": "Scenario analysis",
  "report.sidebar.production": "Production",
  "report.sidebar.ready": "Ready ×{n}",
  "report.sidebar.needDrawing": "Open a drawing to run scenario analysis and AI recommendations.",

  "match.exact": "Exact",
  "match.fuzzy": "Fuzzy",
  "match.dimension": "Dimension",
  "match.embedding": "Embedding",
  "match.embedding_low": "Embedding↓",
  "match.llm": "LLM",
  "match.zilliz": "Zilliz",
  "match.zilliz_med": "Zilliz↓",
  "match.preference": "Memory",
  "match.none": "—",
  "match.noStockPick": "No stock match — pick candidate",

  "dim.openList": "Open dimension list",
  "dim.title": "DIMENSIONS",
  "dim.count": "{n} dims",
  "dim.countPreview": "{n} dims (preview)",
  "dim.previewHint": "Preview dimensions",
  "dim.storyTitle": "Dimension tour",
  "dim.storyHint": "Select dimension steps to walk the part.",
  "dim.empty": "No dimensions",
  "dim.src.dxf": "DXF dim",
  "dim.src.geometry": "geometry",
  "dim.src.preview": "preview",
  "dim.src.text": "text",

  "viewer.parts": "Parts",
  "viewer.stockBadge": "stock",
  "viewer.offlineCount": "Offline: {count}",
  "viewer.loadError": "Load error",
  "viewer.dragTitle": "Drag to move",
  "viewer.resizeTitle": "Resize",

  "error.boundary": "Application error",
  "error.retry": "Retry",
  "error.close": "Close",

  "page.profile.title": "Profile",
  "page.profile.sub": "Manage your account, organization access, and security",
  "page.stock.title": "Stock catalog",
  "page.stock.sub": "Organization stock used for BOM matching and quotes",
  "common.emDash": "—",
  "common.close": "Close",
  "common.loading": "Loading…",
  "common.hours": "{n} h",

  "auth.login.title": "Welcome back",
  "auth.login.blurb": "Sign in to turn drawings into costed quotes.",
  "auth.login.cta": "Sign in",
  "auth.login.switch": "No account yet?",
  "auth.login.switchCta": "Create account",
  "auth.signup.title": "Create account",
  "auth.signup.blurb": "Parse a STEP file, get a BOM, quote it with your own rates.",
  "auth.signup.cta": "Create account",
  "auth.signup.switch": "Already have an account?",
  "auth.signup.switchCta": "Sign in",
  "auth.field.name": "Full name",
  "auth.field.email": "Work email",
  "auth.field.org": "Shop name",
  "auth.field.orgPh": "e.g. Harbor CNC",
  "auth.field.password": "Password",
  "auth.field.passwordCreate": "Create password",
  "auth.field.confirm": "Confirm password",
  "auth.passwordRules": "At least 8 characters.",
  "auth.passwordTooShort": "Password must be at least 8 characters.",
  "auth.consent.before": "I agree to the ",
  "auth.consent.kvkk": "KVKK notice",
  "auth.consent.between": " and the ",
  "auth.consent.terms": "Terms of use",
  "auth.consent.after": ".",
  "auth.consentRequired": "Accept the KVKK notice and Terms of use to create an account.",
  "auth.mismatch": "Does not match yet",
  "auth.busy": "Working…",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.language": "Language",
  "auth.tagline": "From a drawing to a costed quote.",
  "auth.step.drawing": "Drawing",
  "auth.step.features": "Features",
  "auth.step.cost": "Cost",
  "auth.step.quote": "Quote",
  "auth.preview.parts": "Parts",
  "auth.preview.partsCap": "In catalog",
  "auth.preview.boms": "BOMs",
  "auth.preview.bomsCap": "Assemblies",
  "auth.preview.rfqs": "RFQs",
  "auth.preview.rfqsCap": "Open",
  "auth.preview.orders": "Orders",
  "auth.preview.ordersCap": "In shop",
  "auth.preview.coverage": "coverage",
  "auth.preview.parsed": "Parsed · ready to quote",
  "auth.preview.example": "Example",
  "auth.preview.sample": "Sample workshop, not your account",
  "auth.orgMismatch": "This account does not belong to this workspace. Sign in at your own workspace's address.",
  "auth.orgMismatchNamed": "This account does not belong to this workspace ({name}). Sign in at your own workspace's address.",
  "auth.orgApexLink": "Go to the main sign-in",
  "auth.orgSignupRefused": "New accounts cannot be created on a workspace address. Ask your workspace owner for an invitation.",
  "auth.unknownWorkspace": "No workspace exists at this address.",
  "auth.orgInviteOnly": "Members join this workspace by invitation.",
  "auth.orgLogoAlt": "{name} logo",

  "topbar.search": "Search parts, BOMs, RFQs",
  "topbar.signingOut": "Signing out…",
  "topbar.signedIn": "Signed in",
  "home.quick.upload": "Upload",
  "home.kpi.inCatalog": "In catalog",
  "home.kpi.assemblies": "Assemblies parsed",
  "home.kpi.checking": "Checking",
  "home.kpi.clear": "No drawings waiting",
  "home.kpi.waiting": "Waiting on you",
  "home.unit.item": "item",
  "home.unit.items": "items",
  "home.unit.drawing": "drawing",
  "home.unit.drawings": "drawings",
  "home.ordersMark": "OPEN",
  "home.coverage.title": "Quote coverage",
  "home.coverage.cap": "Across open RFQ lines",
  "home.attention.title": "Needs attention",
  "home.uploads.title": "Drawing uploads",
  "home.partsAdded.title": "Parts added",
  "home.readiness.title": "RFQ readiness",
  "drawings.item": "item",
  "drawings.items": "items",
  "drawings.onHand": "on hand {n}",
  "drawings.costPending": "cost pending",
  "drawings.partsCosted": "Parts · costed",
  /** Noun after "{costed} / {total}". Plural follows the total, not the costed count. */
  "drawings.partsCosted.one": "part costed",
  "drawings.partsCosted.other": "parts costed",
  "drawings.emptyBoms": "No BOMs yet.",
  "drawings.emptyParts": "No parts yet.",
  "drawings.emptyReview": "Nothing waiting on review.",
  "drawings.count": "{n} items",
  "docs.search": "Search parts, BOMs or files",
  "docs.upload": "Upload files",
  "docs.sort": "Sort",
  "docs.sort.newest": "Newest",
  "docs.sort.name": "Name",
  "docs.sort.cost": "Last cost",
  "docs.view": "View",
  "docs.view.list": "List",
  "docs.view.cards": "Cards",
  "docs.tab.all": "All",
  "docs.costed": "{n} costed",
  "docs.lastCost": "Last cost {n}",
  "docs.part": "{n} part",
  "docs.parts": "{n} parts",
  "docs.usedOne": "{n} BOM",
  "docs.usedMany": "{n} BOMs",
  "docs.status.processing": "Processing",
  "docs.col.name": "Name",
  "docs.col.status": "Status",
  "docs.col.lastCost": "Last cost",
  "docs.col.modified": "Last modified",
  "docs.col.modifiedBy": "Modified by",
  "docs.col.createdBy": "Created by",
  "docs.col.usedIn": "Used in",
  "docs.menu.open": "Open",
  "docs.menu.rfqs": "Show RFQs",
  "docs.menu.more": "More",
  "docs.emptyReviewTitle": "Nothing needs review",
  "docs.emptyReviewBody": "Parts the system could not read with confidence show up here.",
  "docs.emptyMatchTitle": "No match for “{q}”",
  "docs.emptyMatchBody": "Try a part code, material or RFQ number.",
  "docs.emptyTitle": "No documents yet",
  "docs.emptyBody": "Upload a STEP, DXF, DWG or PDF to get started.",
  "docs.drop": "Drop to upload · STEP, STP, DXF, DWG, PDF",
  "docs.notifyEmpty": "No new notifications",
  "docs.comingSoon": "{label} is coming soon",
  "docs.deleteBody": "{name} leaves the catalog. Parts on this drawing go with it.",
  "docs.deleting": "Deleting…",
  "profile.nav.users": "Users",
  "profile.nav.alerts": "Notifications",
  "profile.settingsTitle": "Settings",
  "profile.settingsSub": "Organization, users and alerts",
  "erp.nav.capacity": "Capacity",
  "erp.nav.costing": "Costing",
  "erp.search.overview": "Search stock, POs, WOs",
  "erp.search.movements": "Search movements",
  "erp.search.po": "Search purchase orders",
  "erp.search.wo": "Search work orders",
  "erp.search.hours": "Search operation or machine",
  "erp.search.machines": "Search machines",
  "erp.search.capacity": "Search machines",
  "erp.search.costing": "Search cost drivers",
  "erp.search.accuracy": "Search operation or part",
  "erp.blurb.hours": "Clock setup and run time against a released work order",
  "erp.blurb.capacity": "Machine load behind every promised date",
  "erp.blurb.costing": "Rates and defaults that turn hours into money",
  "erp.blurb.accuracy": "Estimated against actual hours on finished operations",
  "erp.skuLine": "{n} SKU",
  "erp.skuLines": "{n} SKUs",
  "erp.openWoLine": "{n} open WO",
  "erp.openPoLine": "{n} open PO",
  "erp.movesLine": "{n} {move} today · {total} recorded",
  "erp.moveOne": "move",
  "erp.moveMany": "moves",
  "erp.overviewBlurb": "Stock master, movements, POs and work orders",
  "erp.kpi.stockMaster": "Stock master",
  "erp.kpi.nothingBuy": "Nothing to purchase",
  "erp.kpi.needsBuy": "Needs purchase",
  "erp.kpi.purchaseOrders": "Purchase orders",
  "erp.unit.item": "item",
  "erp.unit.items": "items",
  "erp.unit.order": "order",
  "erp.unit.orders": "orders",
  "ai.tour.stops": "Tour stops",
  "ai.tour.progress": "Stop {current} of {total}",
  "ai.tour.failed": "The tour over the drawing could not be prepared. The answer is in the chat.",
  "viewer.tourBack": "Back",
  "viewer.tourNext": "Next",

  "erp.sort.part": "Part",
  "erp.sort.onHand": "On hand",
  "erp.sort.shortfall": "Shortfall",
  "erp.sort.newest": "Newest",
  "erp.sort.hours": "Est. hours",
  "erp.sort.number": "Number",
  "erp.sort.total": "Total",
  "erp.open": "Open",
  "erp.closed": "Closed",
  "live.erp.stockEmpty": "No stock items yet.",
  "erp.stockNoMatch": "No item matches this filter.",
  "erp.stockFilter": "Stock filter",
  "erp.receipt": "Receipt",
  "erp.return": "Return",
  "erp.movEmptyTitle": "No stock movements yet",
  "erp.movTitle": "Stock movements",
  "erp.movNone": "No movement matches this filter.",
  "erp.col.balanceAfter": "Balance after",
  "erp.col.time": "Time",
  "erp.col.type": "Type",
  "erp.col.created": "Created",
  "erp.col.estHours": "Est. hours",
  "live.erp.woEmpty": "No work orders yet.",
  "erp.woNoMatch": "No work order matches this filter.",
  "erp.woFilter": "Work order filter",
  "live.erp.poEmpty": "No purchase orders yet.",
  "erp.poNoMatch": "No order matches this filter.",
  "erp.poFilter": "Purchase filter",
  "erp.po.part": "Part no",
  "erp.po.qty": "Qty",
  "erp.po.price": "Unit ₺",
  "live.erp.po.notes": "Notes (supplier, terms…)",
  "erp.po.notesLabel": "Notes",
  "erp.po.creating": "Creating…",
  "erp.po.createDraft": "Create draft",
  "erp.hours.release": "No released work order. Release one from Work orders before clocking hours.",
  "erp.hours.none": "No released work order",
  "erp.hours.view": "View",
  "erp.hours.entry": "Hours entry",
  "erp.hours.cost": "Cost",
  "erp.hours.noCost": "No cost has been written for this work order yet.",
  "erp.hours.noOps": "This work order has no operations on its routing.",
  "erp.hours.noMatch": "No operation matches this search.",
  "erp.cost.material": "Material",
  "erp.cost.stockIssue": "Stock issue",
  "erp.cost.labour": "Labour",
  "erp.cost.machineRate": "Machine hourly rate",
  "erp.cost.perUnit": "Per good unit",
  "erp.cost.against": "Against estimate",
  "erp.cost.estimated": "{n} estimated",
  "erp.cost.noEstimate": "No estimate",
  "erp.col.item": "Item",
  "erp.col.basis": "Basis",
  "erp.col.op": "Op",
  "erp.col.operation": "Operation",
  "erp.col.machine": "Machine",
  "erp.col.estH": "Estimated h",
  "erp.col.actH": "Actual h",
  "erp.col.setupH": "Setup h",
  "erp.col.runH": "Run h",
  "erp.col.runUnit": "Run h/unit",
  "erp.col.required": "Required",
  "erp.col.issued": "Issued",
  "erp.notAssigned": "Not assigned",
  "erp.col.good": "Good",
  "erp.col.scrap": "Scrap",
  "erp.col.seq": "Seq",
  "live.erp.machines.noRate": "no rate",
  "erp.machines.emptyTitle": "No machines yet",
  "erp.machines.emptyBody": "The hourly rate is what turns clocked hours into money. Labour cost stays at 0 ₺ until at least one machine exists.",
  "set.org": "Organization",
  "set.profile": "Your profile",
  "set.name": "Name",
  "set.slug": "Slug",
  "set.signedInAs": "Signed in as",
  "set.displayName": "Display name",
  "set.saving": "Saving…",
  "set.save": "Save",
  "set.usersNote": "Only your own account is shown: the engine exposes the signed-in user but no endpoint to list or invite members of the organization.",
  "set.notifyBlurb": "Choose which events reach you and when.",
  "set.reset": "Reset",
  "set.events": "Event types",
  "set.eventsBlurb": "Select the events you want to be notified about.",
  "set.reach": "Will reach you",
  "set.muted": "Muted",
  "set.held": "Held by the silent window",
  "set.off": "Off",
  "set.schedule": "Delivery schedule",
  "set.scheduleBlurb": "Set when alerts are allowed to reach you.",
  "set.anytime": "Anytime",
  "set.anytimeHint": "Alerts arrive as they happen",
  "set.shopHours": "During shop hours",
  "set.shopHoursHint": "Held outside working hours",
  "set.silent": "Silent",
  "set.silentHint": "Only what you mark urgent gets through",
  "set.muteAll": "Mute every alert channel",
  "set.priority": "Priority",
  "set.priorityBlurb": "Decide which alerts are marked urgent. High ones get through a silent window.",
  "set.priHigh": "High · cost blocking",
  "set.priMed": "Medium · review needed",
  "set.priLow": "Low · informational",
  "set.local": "These choices stay on this device.",
  "set.saved": "Saved on this device.",
  "set.ev.parse": "Drawing parse failed",
  "set.ev.stock": "Stock below minimum",
  "set.ev.rfq": "RFQ waiting for review",
  "set.ev.wo": "Work order overdue",
  "set.ev.supplier": "Supplier quote received",
  "set.nameSaved": "Display name updated.",
  "set.passwordSaved": "Password changed.",
  "shop.companyNotSaved": "Legal name, tax office, tax number, address, phone, quote e-mail and logo are not saved yet. Save writes margin, validity, overhead and scrap to the organization.",
  "shop.logoNotSaved": "A company logo is not saved yet.",
  "brand.title": "Workspace branding",
  "brand.blurb": "Shown on your workspace address (sign-in page, sidebar and browser tab). Everything here is public.",
  "brand.ownerOnly": "Only the workspace owner can change branding.",
  "brand.name": "Display name",
  "brand.namePh": "e.g. Acme Metal",
  "brand.logo": "Logo URL",
  "brand.logoHint": "An https link to a PNG or SVG.",
  "brand.accent": "Accent colour",
  "brand.accentHint": "Hex, for example #f1c232. Text on it switches between white and black for contrast.",
  "brand.preview": "Preview",
  "brand.save": "Save branding",
  "brand.saving": "Saving…",
  "brand.saved": "Branding saved.",
  "brand.cancel": "Cancel",
  "brand.err.name": "Use 1–80 characters, without < or >.",
  "brand.err.logo": "Enter an https URL without a username or password.",
  "brand.err.accent": "Enter a colour as #rrggbb.",
  "brand.notLoaded": "Branding could not be loaded.",
  "shop.notSavedYet": "Not saved yet.",
  "shop.quoteBlurb": "Margin and validity are saved with the organization. New quotes start from them.",
  "shop.costBlurb": "Overhead and scrap are saved with the organization and used in the cost formula.",
  "shop.saved": "Margin, validity, overhead and scrap saved.",
  "settings.sub": "Workspace, shop rates, machines and alerts",
  "settings.tabs": "Settings",
  "settings.tab.general": "General",
  "settings.tab.shop": "Shop profile",
  "settings.tab.machines": "Machines",
  "settings.tab.labour": "Labour types",
  "settings.kpi.workspace": "Workspace",
  "settings.kpi.currency": "Currency",
  "settings.kpi.machines": "Machines",
  "settings.kpi.labour": "Labour types",
  "settings.workspace": "Workspace",
  "settings.workspaceBlurb": "Basic preferences for the interface and calculations.",
  "settings.workspaceName": "Workspace name",
  "settings.language": "Interface language",
  "settings.lang.en": "English",
  "settings.lang.tr": "Türkçe",
  "settings.currency": "Currency",
  "settings.currencyUnloaded": "Currency is not loaded.",
  "settings.currencyHint": "Quotes are prepared in this currency.",
  "settings.currency.try": "TRY (₺)",
  "settings.currency.eur": "EUR (€)",
  "settings.currency.usd": "USD ($)",
  "settings.units": "Unit system",
  "settings.unitsValue": "Metric (mm, kg)",
  "settings.timezone": "Time zone",
  "settings.number": "Number format",
  "settings.numberHint": "Follows the interface language.",
  "settings.users": "Users",
  "settings.noUser": "No signed-in user.",
  "settings.cancel": "Cancel",
  "settings.company": "Company details",
  "settings.legal": "Legal name",
  "settings.taxOffice": "Tax office",
  "settings.taxNumber": "Tax number",
  "settings.address": "Address",
  "settings.phone": "Phone",
  "settings.quoteEmail": "Quote e-mail",
  "settings.logo": "Company logo",
  "settings.quoteDefaults": "Quote defaults",
  "settings.margin": "Default margin",
  "settings.notLoaded": "Not loaded.",
  "settings.boughtMargin": "Margin on purchased parts",
  "settings.validity": "Quote validity",
  "settings.days": "days",
  "settings.payment": "Payment terms",
  "settings.note": "Quote note template",
  "settings.cost": "Cost and capacity",
  "settings.overhead": "Overhead share",
  "settings.overheadHint": "Indirect costs such as rent, energy and depreciation.",
  "settings.scrap": "Default scrap rate",
  "settings.shift": "Shift pattern",
  "settings.week": "Working week",
  "settings.addMachine": "Add machine",
  "settings.col.field": "Field",
  "settings.col.value": "Value",
  "settings.col.machine": "Machine",
  "settings.col.ops": "Operations",
  "settings.col.hourly": "Hourly cost",
  "settings.col.setup": "Default setup",
  "settings.col.capacity": "Capacity",
  "settings.col.active": "Active",
  "settings.machinesUnknown": "No machine list in this session.",
  "settings.machinesEmpty": "No machines yet.",
  "settings.tryPerHour": "{value} ₺/h",
  "settings.hoursDay": "{n} h/day",
  "settings.activate": "Activate {name}",
  "settings.deactivate": "Deactivate {name}",
  "settings.machine.title": "Add machine",
  "settings.machine.body": "Operations on parts are routed to machines by capability and size. You can refine values later from actual times.",
  "settings.machine.name": "Machine name",
  "settings.machine.type": "Type",
  "settings.machine.code": "Code",
  "settings.machine.ops": "Operations",
  "settings.notStored": "Not stored.",
  "settings.machine.hourly": "Hourly cost",
  "settings.machine.hourlyHint": "Energy, depreciation and maintenance.",
  "settings.machine.setup": "Default setup",
  "settings.machine.sheet": "Max sheet size",
  "settings.machine.thickness": "Max thickness",
  "settings.machine.operator": "Operator cost included",
  "settings.machine.save": "Save machine",
  "settings.addLabour": "Add labour type",
  "settings.col.role": "Role",
  "settings.col.used": "Used in operations",
  "settings.col.rate": "Hourly rate",
  "settings.col.people": "People",
  "settings.col.updated": "Last updated",
  "settings.labourRole": "Shop labour rate",
  "settings.op.grinding": "Grinding",
  "settings.op.assembly": "Assembly",
  "settings.op.programming": "Programming",
  "settings.op.deburring": "Deburring",
  "settings.labourUnknown": "No labour types are stored.",
  "settings.labourEmpty": "No labour rate is stored.",
  "settings.labourHow": "How machine and labour rates combine",
  "settings.labourHowBody": "Machine operations use the hourly cost on the Machines tab. Grinding, assembly, programming and deburring use this shop labour rate.",
  "settings.labour.title": "Add labour type",
  "settings.labour.body": "The shop stores one labour rate, for grinding, assembly, programming and deburring.",
  "settings.labour.role": "Role",
  "settings.labour.rate": "Hourly rate",
  "settings.labour.people": "People",
  "settings.labour.save": "Save",
  "settings.err.pct": "Enter a percentage from 0 to 100.",
  "settings.err.days": "Enter a number of days.",
  "settings.err.code": "Enter a machine code.",
  "settings.err.hourly": "Enter an hourly cost of 0 or more.",
  "settings.err.machineE2e": "Machines are not saved in this session.",
  "settings.err.labourUnloaded": "Labour rate is not loaded.",
  "settings.err.labourRate": "Enter an hourly rate of 0 or more.",
  "settings.err.labourE2e": "Labour types are not saved in this session.",
  "integrations.emptyTitle": "Integrations aren't available yet",
  "integrations.emptyBody": "There is no connector to configure. This page stays empty until the product has one.",

  "erp.export": "Export",
  "erp.cancel": "Cancel",
  "erp.rate": "Rate",
  "erp.group": "Group",
  "erp.hours": "Hours",
  "erp.openCol": "Open",
  "erp.quantity": "Quantity",
  "erp.sourceJob": "Source job",
  "erp.progress": "Progress",
  "erp.release": "Release",
  "erp.complete": "Complete",
  "erp.submit": "Submit",
  "erp.receive": "Receive",
  "erp.allWo": "All work orders",
  "erp.woView": "Work order view",
  "erp.estimated": "Estimated",
  "erp.recorded": "Recorded",
  "erp.fromRouting": "From routing",
  "erp.clocked": "Clocked",
  "erp.clockedSoFar": "Clocked so far",
  "erp.hoursVariance": "Hours variance",
  "erp.actualVsEst": "Actual vs estimate",
  "erp.scrapRate": "Scrap rate",
  "erp.goodVsScrap": "Good vs scrap",
  "erp.goodScrap": "Good / scrap",
  "erp.completion": "Completion",
  "erp.goodOf": "{good} of {qty} good",
  "erp.noQty": "No quantity on the order",
  "erp.scrapped": "{n} scrapped",
  "erp.variance": "Variance",
  "erp.labourAndMaterial": "Labour and material",
  "erp.costSummary": "Cost summary",
  "erp.noReleasedShort": "No released work order.",
  "erp.clocking": "Clocking",
  "erp.sort.sequence": "Sequence",
  "erp.sort.longest": "Longest",
  "erp.sort.workOrder": "Work order",
  "erp.noMaterial": "No material is reserved against this work order.",
  "erp.issueN": "Issue {n}",
  "erp.issuedDone": "Issued",
  "erp.noCostRollup": "No cost has been rolled up yet — clock hours or issue material first.",
  "erp.labourShare": "Labour share",
  "erp.pctOfTotal": "{n}% of total",
  "erp.shopOff": "Shop-floor tracking is off for this organization.",
  "erp.start": "Start",
  "erp.finish": "Finish",
  "erp.po.new": "New purchase order",
  "erp.po.linePart": "Line {n} part",
  "erp.po.lineQty": "Line {n} quantity",
  "erp.po.linePrice": "Line {n} unit price",
  "live.erp.po.removeLine": "Remove line {n}",

  "erp.st.released": "Released",
  "erp.st.completed": "Completed",
  "erp.st.done": "Done",
  "erp.st.closed": "Closed",
  "erp.st.running": "Running",
  "erp.st.pending": "Pending",
  "erp.st.active": "Active",

  "erp.allMachines": "All machines",
  "erp.machineView": "Machine view",
  "erp.editRates": "Edit rates",
  "erp.editRate": "Edit rate",
  "erp.thisWeek": "This week",
  "erp.weekBlurb": "Routing hours booked by open work orders against five days of capacity",
  "erp.scheduled": "Scheduled",
  "erp.hoursBooked": "Hours booked",
  "erp.utilisation": "Utilisation",
  "erp.againstCap": "Against {n} capacity",
  "erp.noCapacity": "No capacity set",
  "erp.overCapacity": "Over capacity",
  "erp.pastWeek": "Past what the week holds",
  "erp.withinCap": "Within capacity",
  "erp.routingBooked": "Routing hours booked by open work orders",
  "erp.hourlyRate": "Hourly rate",
  "erp.hourlyRateField": "Hourly rate ₺/h",
  "erp.capacity": "Capacity",
  "erp.capacityDay": "Capacity h/day",
  "erp.notSet": "Not set",
  "erp.notSetLabour": "Not set — labour cost stays at 0 ₺",
  "erp.hPerDay": "{n} h/day",
  "erp.machineFallback": "Machine",
  "erp.machineList": "Machine list",
  "erp.ratePerH": "Rate ₺/h",
  "erp.addMachine": "Add machine",
  "erp.addMachineBody": "Name, group and hourly rate. That is the minimum to get real cost.",
  "erp.add": "Add",
  "erp.setRates": "Set hourly rates",
  "erp.setRatesBody": "Separate setup and run rates when they differ.",
  "erp.setRatesCta": "Set rates",
  "erp.linkOps": "Link to operations",
  "erp.linkOpsBody": "Bind routing steps to machines so estimates pick the right rate.",
  "erp.link": "Link",
  "erp.code": "Code",
  "erp.sortCode": "Sort · code",
  "erp.sortRate": "Sort · rate",
  "erp.machines.searchEmpty": "No machine matches this search.",
  "erp.machines.noneYet": "No machines yet. Labour cost stays at 0 ₺ until one exists with an hourly rate.",
  "erp.load": "Load",
  "erp.booked": "Booked",
  "erp.noOpenBooks": "No open work order books this machine.",
  "erp.noCapacitySet": "{n} · no capacity set",
  "erp.ofCapacity": "{booked} of {capacity}",
  "erp.rateError": "Hourly rate must be a number of 0 or more.",
  "erp.capError": "Capacity must be a number of 0 or more.",
  "erp.rateFor": "Hourly rate for {code}",

  "erp.movFilter": "Movement kind",
  "erp.receiveStock": "Receive stock",
  "erp.receiveBody": "Book incoming material against a purchase order or a manual entry.",
  "erp.issueToWo": "Issue to work order",
  "erp.issueBody": "Consume material from stock when a work order is released.",
  "erp.adjustQty": "Adjust quantity",
  "erp.adjustBody": "Correct on-hand after a count, scrap or swarf return.",
  "erp.importCsv": "Import CSV",
  "erp.importBody": "Bulk-load an opening balance from your existing sheet.",
  "erp.importing": "Importing…",
  "erp.import": "Import",
  "erp.movExplain": "Every receipt, issue and adjustment lands here with a timestamp, so on-hand quantity stays explainable.",

  "erp.mostLoaded": "Most loaded",
  "erp.mostHours": "Most hours",
  "erp.scheduleWo": "Schedule work order",
  "erp.bookedCaption": "Routing hours on open WOs",
  "erp.capacityCaption": "Active machines, 5 days",
  "erp.overbooked": "Overbooked",
  "erp.overbookedCaption": "Machines past capacity",
  "erp.unassigned": "Unassigned",
  "erp.unassignedCaption": "No machine on the routing",
  "erp.nothingBooked": "Nothing booked.",
  "erp.noActiveMachines": "No active machines to schedule against.",
  "erp.noMachineFilter": "No machine matches this filter.",
  "erp.hoursFoot": "Hours are booked against the machine each open work order names.",
  "erp.loadedPct": "{label} · {pct}% loaded",
  "erp.piece": "piece",
  "erp.pieces": "pieces",
  "erp.booking": "{what}, {qty} {unit}. Estimated {hours}{setup}.{status}",
  "erp.inclSetup": " including {h} setup",
  "erp.runningNow": " Running now.",
  "erp.doneNow": " Done.",
  "erp.opMark": "op {n}",

  "erp.cost.rates": "Rates",
  "erp.cost.margin": "Margin",
  "erp.cost.driver": "Costing driver",
  "erp.cost.readBy": "Read by the engine every time an RFQ line is priced.",
  "erp.cost.savedNote": "Saved for the organization. Open quotes pick it up on their next recalculation.",
  "erp.cost.rateDefaults": "Rate defaults",
  "erp.cost.rateDefaultsBlurb": "Used when no machine in the park carries a rate for the process. Leave a field blank to fall back to the template.",
  "erp.cost.machineLabour": "Machine and labour",
  "erp.cost.pricedNow": "What a quote is priced with now",
  "erp.cost.pricedNowBlurb": "Machine park beats these defaults, which beat the template.",
  "erp.cost.process": "Process",
  "erp.cost.source": "Source",
  "erp.cost.ratesTitle": "Machine and labour rates",
  "erp.cost.ratesBlurb": "What an hour on each machine costs. The median per process prices quotes and work orders costed after the change.",
  "erp.cost.noActive": "No active machines. Quotes use the rate defaults above until one exists.",
  "erp.cost.pricedCount": "{priced} of {total} active machines carry a rate.",
  "erp.cost.materialOverhead": "Material and overhead",
  "erp.cost.materialBlurb": "Material on a line comes from the drawing, a stock price or the supplier; the steel price here is the fallback per kg. Overhead is added on top of operations and material for every quoted line.",
  "erp.cost.overhead": "Overhead %",
  "erp.cost.scrapAllow": "Scrap allowance % (reported, not priced)",
  "erp.cost.steel": "Fallback steel price ₺/kg",
  "erp.cost.market": "market rate",
  "erp.cost.currency": "Currency",
  "erp.cost.marginDefaults": "Margin and quote defaults",
  "erp.cost.marginBlurb": "The engine starts its margin suggestion from this default and moves it with the win rate; an approver fixes the final margin on each quote. Rounding and validity land on the quote PDF.",
  "erp.cost.marginPct": "Default margin %",
  "erp.cost.validity": "Quote validity, days",
  "erp.cost.leadBuffer": "Lead time buffer, days",
  "erp.cost.rounding": "Rounding",
  "erp.cost.noRounding": "No rounding",
  "erp.cost.nearest1": "Nearest 1 ₺",
  "erp.cost.nearest10": "Nearest 10 ₺",
  "erp.cost.nearest100": "Nearest 100 ₺",
  "erp.cost.labourH": "Labour ₺/h",
  "erp.cost.turningH": "Turning ₺/h",
  "erp.cost.millingH": "Milling ₺/h",
  "erp.cost.cuttingH": "Cutting / laser ₺/h",
  "erp.cost.drillingH": "Drilling ₺/h",
  "erp.cost.weldingH": "Welding ₺/h",
  "erp.cost.bendingH": "Bending ₺/h",
  "erp.cost.turning": "Turning",
  "erp.cost.milling": "Milling",
  "erp.cost.cutting": "Cutting / laser",
  "erp.cost.drilling": "Drilling",
  "erp.cost.welding": "Welding",
  "erp.cost.bending": "Bending",

  "erp.acc.under": "Under-quoted",
  "erp.acc.watch": "Watch",
  "erp.acc.target": "On target",
  "erp.acc.over": "Over-quoted",
  "erp.acc.worst": "Worst ratio",
  "erp.acc.mostJobs": "Most jobs",
  "erp.acc.mostHours": "Most hours",
  "live.erp.acc.variance": "Operation variance",
  "erp.acc.across": "Across {n} finished operations",
  "erp.acc.noneYet": "No finished operations yet — clock hours against a released work order first.",
  "erp.acc.noMatch": "No operation matches this filter.",
  "erp.acc.jobs": "Jobs",
  "erp.acc.clock": "Clock hours",
  "erp.acc.clockBody": "Record duration, good and scrap against a released work order.",
  "erp.acc.openTerminal": "Open terminal",
  "erp.acc.closeWo": "Close a work order",
  "erp.acc.closeBody": "Closing writes the actual hours this report reads.",
  "erp.acc.closeCta": "Close WO",
  "erp.acc.compare": "Compare to estimate",
  "erp.acc.compareBody": "See variance per operation once the first job is closed.",
  "erp.acc.preview": "Preview",
  "erp.acc.emptyTitle": "Nothing to compare yet",
  "erp.acc.emptyBody": "This compares estimated against actual hours on finished operations. A ratio above 1 means we keep under-quoting that process.",
  "erp.acc.exportTitle": "Export report",
  "erp.acc.exportBody": "Send the variance table to your costing sheet — once there is one.",
  "erp.acc.allOps": "All operations",
  "erp.acc.ratioTitle": "Actual vs estimated ratio",
  "erp.acc.ratioBlurb": "A ratio above 1 means we keep under-quoting",
  "erp.acc.avg": "Average ratio · hours-weighted across {n} {unit}",
  "erp.acc.opOne": "operation",
  "erp.acc.opMany": "operations",
  "erp.acc.seriesRatio": "Actual / estimated",
  "erp.acc.emptyChart": "No finished operations to compare yet.",
  "erp.acc.estimateMet": "Estimate met",
  "erp.acc.byOp": "Variance by operation",
  "erp.acc.byOpBlurb": "Estimated beside actual, in hours",

  "erp.ov.openWo": "Open WO",
  "erp.ov.openCount": "{n} OPEN",
  "erp.ov.coverage": "Stock coverage",
  "erp.ov.againstMin": "Against minimum levels",
  "erp.ov.onTrack": "On track",
  "erp.ov.action": "Action needed",
  "erp.ov.share": "Share of tracked SKUs at or above their minimum",
  "erp.ov.noMin": "No SKU has a minimum set",
  "erp.ov.setMin": "Set a minimum on a SKU to start tracking coverage.",
  "erp.ov.atMin": "{ok} of {tracked} tracked SKUs at or above minimum",
  "erp.ov.addStock": "Add stock",
  "erp.ov.nothingBlocking": "Nothing blocking right now.",
  "erp.ov.lastN": "Last {n} days",
  "erp.ov.openMovements": "Open movements",
  "erp.ov.noMovesWindow": "No stock movements in the last {n} days.",
  "erp.ov.noMoves": "No moves",
  "erp.ov.oneMove": "One move",
  "erp.ov.moving": "Moving",
  "erp.ov.moveCallout": "{n} {move} today · {total} in {days} days",
  "erp.ov.stockValue": "Stock value",
  "erp.ov.openStock": "Open stock",
  "erp.ov.committed": "Committed",
  "erp.ov.pctOnHand": "{n}% of on hand",
  "erp.ov.acrossSku": " across {n} priced SKU",
  "erp.ov.acrossSkus": " across {n} priced SKUs",
  "erp.ov.readiness": "ERP readiness",
  "erp.ov.readinessBlurb": "What must exist before ERP can cost a job",
  "erp.ov.setup": "Setup",
  "erp.ov.incomplete": "Incomplete",
  "erp.ov.ready": "Ready",
  "erp.ov.next": "Next step",
  "erp.ov.nextStock": "Add a stock item so purchasing and work orders have something to draw from.",
  "erp.ov.nextMachine": "Add one machine with an hourly rate. Labour cost stays at 0 ₺ until a machine has one.",
  "erp.ov.nextWo": "Release a work order. Cost stays empty until hours are clocked against it.",
  "erp.ov.releaseWo": "Release work order",
  "erp.ov.activity": "Recent activity",
  "erp.ov.noActivity": "No ERP activity yet.",
  "erp.ov.noKind": "Nothing of that kind yet.",
  "erp.ov.pricedOf": "{n} of {total} priced",
  "erp.ov.nDraft": "{n} draft",

  "erp.attn.belowMin": "{name} is below minimum",
  "erp.attn.noMachines": "No machines configured",
  "erp.attn.noRate": "No machine has an hourly rate",
  "erp.attn.minimum": "Minimum",
  "erp.attn.needed": "Needed",
  "erp.attn.atLeast1": "at least 1",
  "erp.attn.reserve": "Reserve or raise a purchase order before releasing a work order.",
  "erp.attn.rateNote": "The hourly rate is what turns clocked hours into money. Labour cost stays at 0 ₺ until a machine has one.",
  "erp.attn.srcStock": "ERP · Stock",
  "erp.attn.srcMachines": "ERP · Machines",
  "erp.kind.receipts": "Receipts",
  "erp.kind.issues": "Issues",
  "erp.kind.adjust": "Adjust",
  "erp.kind.scrap": "Scrap",
  "erp.kind.returns": "Returns",
  "erp.day.mon": "Mon",
  "erp.day.tue": "Tue",
  "erp.day.wed": "Wed",
  "erp.day.thu": "Thu",
  "erp.day.fri": "Fri",
  "erp.day.sat": "Sat",
  "erp.day.sun": "Sun",
  "erp.acc.shopOff": "Shop-floor tracking is off for this organization, so there are no clocked hours to compare.",
  "erp.cap.shopOff": "Shop-floor tracking is off, so no routing hours can be booked.",
  "erp.cap.partial": "Some routings could not be read; load is partial.",
  "erp.machineCodeRequired": "Machine code is required.",

  "quotePdf.title": "Quote PDF",
  "quotePdf.inclVat": "incl. VAT",
  "quotePdf.thumbs": "Part thumbnails",
  "quotePdf.codes": "Part codes",
  "quotePdf.prices": "Unit prices",
  "quotePdf.language": "Document language",
  "quotePdf.langEn": "English",
  "quotePdf.langTr": "Türkçe",
  "quotePdf.currency": "Currency",
  "quotePdf.currencyTry": "TRY (₺)",
  "quotePdf.currencyEur": "EUR (€)",
  "quotePdf.currencyUsd": "USD ($)",
  "quotePdf.noRate": "No exchange rate is stored, so this currency cannot be printed.",
  "quotePdf.disclaimer": "Cost and margin are never included in the PDF. The quote is downloaded; SemantiCAD does not track sending.",
  "quotePdf.download": "Download PDF",
  "quotePdf.preparing": "Preparing…",
  "quotePdf.back": "Back to draft",
  "quotePdf.close": "Close",
  "quotePdf.docTitle": "QUOTE",
  "quotePdf.number": "No",
  "quotePdf.date": "Date",
  "quotePdf.validUntil": "Valid until",
  "quotePdf.validDays": "{days} days",
  "quotePdf.payment": "Payment",
  "quotePdf.customer": "CUSTOMER",
  "quotePdf.subject": "SUBJECT",
  "quotePdf.colPart": "Part",
  "quotePdf.colCode": "Code",
  "quotePdf.colQty": "Qty",
  "quotePdf.colUnit": "Unit price",
  "quotePdf.colTotal": "Total",
  "quotePdf.subtotal": "Subtotal",
  "quotePdf.vat": "VAT {rate}%",
  "quotePdf.grand": "Grand total",
  "quotePdf.lead": "Lead time: {days} days",
  "quotePdf.pricesExVat": "Prices exclude VAT.",
  "quotePdf.page": "Page {page} / {pages}",
  "quotePdf.prepared": "Prepared with SemantiCAD",
  "quotePdf.lineFallback": "Line {n}",
  "quotePdf.tax": "Tax: {value}",

  "ds.sidebar.collapse": "Collapse sidebar",
  "ds.sidebar.expand": "Expand sidebar",
  "ds.sidebar.nav": "Navigation",
  "ds.list.sortBy": "Sort by {column}",
  "ds.list.sortedAsc": "ascending",
  "ds.list.sortedDesc": "descending",
  "ds.topbar.searchLabel": "Search",
  "ds.topbar.themeToDark": "Dark mode",
  "ds.topbar.themeToLight": "Light mode",
  "ds.topbar.notifications": "Notifications",
  "ds.alert.title": "Waiting on you",
  "ds.alert.cat.stock": "Missing stock match",
  "ds.alert.cat.bom": "BOM awaiting approval",
  "ds.alert.cat.confidence": "Low-confidence part",
  "ds.alert.cat.dfm": "DFM warning",
  "ds.alert.cat.price": "Price approval",
  "ds.alert.cat.setup": "Setup",
  "ds.setup.progress": "{done} of {total}",
  "ds.setup.done": "Done",
  "ds.setup.next": "Next",
  "ds.setup.later": "Later",
  "ds.stepper.progress": "Stage {current} of {total}: {label}",
  "ds.stepper.next": "next: {label}",
  "ds.stepper.tip": "{n} · {label} — {state}",
  "ds.stepper.state.done": "done",
  "ds.stepper.state.current": "current",
  "ds.stepper.state.upcoming": "upcoming",
  "ds.ask.send": "Send",
  "ds.attention.example": "example",
  "ds.attention.emptyTitle": "Nothing needs attention",
  "ds.attention.emptyBody": "Parts with confidence under 70%, DFM warnings or unmatched stock show up here.",
  "ds.stage.files": "Files",
  "ds.stage.stock": "Stock matching",
  "ds.stage.bom": "BOM",
  "ds.stage.params": "Parameters",
  "ds.stage.cost": "Cost",
  "ds.stage.quote": "Quote",
  "ds.stage.outcome": "Outcome",
  "ds.gallery.welcome": "Welcome, {name}",
  "ds.gallery.brand": "Semanti",
  "ds.gallery.brandAccent": "CAD",
  "ds.gallery.mark": "S",
  "ds.gallery.userName": "Example user",
  "ds.gallery.userEmail": "owner@example.local",
  "ds.gallery.initials": "EX",
  "ds.gallery.searchPlaceholder": "Search RFQs, documents or parts",
  "ds.gallery.primary": "New quote",
  "ds.gallery.dueTitle": "Due dates",
  "ds.gallery.dueMeta": "Example",
  "ds.gallery.overdue": "Overdue",
  "ds.gallery.dueToday": "Due today",
  "ds.gallery.thisWeek": "This week",
  "ds.gallery.setupTitle": "Shop setup",
  "ds.gallery.stepMachines": "Machines",
  "ds.gallery.stepMachinesBody": "None yet. Add machines to cost labour.",
  "ds.gallery.stepStock": "Materials and stock",
  "ds.gallery.stepStockBody": "Example item in stock.",
  "ds.gallery.stepPricing": "Pricing and margin",
  "ds.gallery.stepPricingBody": "Set default margin and overheads.",
  "ds.gallery.add": "Add",
  "ds.gallery.import": "Import",
  "ds.gallery.setupAction": "Set up",
  "ds.gallery.rfqTitle": "Recent RFQs",
  "ds.gallery.colRfq": "RFQ",
  "ds.gallery.colStage": "Stage",
  "ds.gallery.colDue": "Due",
  "ds.gallery.allRfqs": "Go to RFQs",
  "ds.gallery.exampleRfq": "Example RFQ",
  "ds.gallery.exampleRfqId": "RFQ-EXAMPLE-0001",
  "ds.gallery.exampleRfq2": "Example plate",
  "ds.gallery.exampleRfq2Id": "RFQ-EXAMPLE-0002",
  "ds.gallery.exampleDue": "4 Oct",
  "ds.gallery.exampleRfq3": "Example housing",
  "ds.gallery.exampleRfq3Id": "RFQ-EXAMPLE-0003",
  "ds.gallery.exampleRfq4": "Example cover",
  "ds.gallery.exampleRfq4Id": "RFQ-EXAMPLE-0004",
  "ds.gallery.exampleRfq5": "Example flange",
  "ds.gallery.exampleRfq5Id": "RFQ-EXAMPLE-0005",
  "ds.gallery.askTitle": "Ask AI",
  "ds.gallery.askMeta": "About your RFQs, parts and stock",
  "ds.gallery.askPlaceholder": "Ask anything about your data",
  "ds.gallery.suggest1": "Which example lines have no stock match?",
  "ds.gallery.suggest2": "What is blocking the example RFQ?",
  "ds.gallery.suggest3": "Why is example labour costed at 0?",
  "ds.gallery.attentionTitle": "Parts needing attention",
  "ds.gallery.partsCount": "{count} parts",
  "ds.gallery.partMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.partReason": "Confidence 62%",
  "ds.gallery.partDfmName": "Example bracket",
  "ds.gallery.partDfm": "DFM warning",
  "ds.gallery.partStockName": "Example shaft",
  "ds.gallery.partStock": "No stock match",
  "ds.gallery.review": "Review",
  "ds.gallery.taskStockMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.match": "Match",
  "ds.gallery.taskBomMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.approve": "Approve",
  "ds.gallery.taskConfMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.open": "Open",
  "ds.gallery.taskDfmMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.taskPriceMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.taskSetupMeta": "Settings · Machines",
  "ds.gallery.addMachine": "Add machine",
  "ds.gallery.toast": "Example notice",

  "sidebar.hint.production": "Work orders, operations, and shop time",
  "production.title": "Production",
  "production.sub": "Work orders and the time booked against them.",
  "production.search": "Search number, part or note",
  "production.filters": "Filter work orders",
  "production.filter.all": "All",
  "production.filter.open": "Open",
  "production.filter.closed": "Closed",
  "production.kpi.open": "Open",
  "production.kpi.released": "Released",
  "production.kpi.closed": "Closed",
  "production.kpi.hours": "Open estimated hours",
  "production.col.wo": "Work order",
  "production.col.notes": "Notes",
  "production.emptyTitle": "No work orders yet",
  "production.emptyBody": "A work order appears here when a job is released to the shop.",
  "production.noMatchTitle": "No match for “{query}”",
  "production.noMatchHint": "Try another number or part.",
  "production.noFilter": "No work orders in this filter.",
  "production.unavailableTitle": "Shop-floor tracking is off",
  "production.unavailableBody": "Work-order tracking is not enabled for this organization. There is nothing to show until it is turned on.",
  "production.bulk.one": "{n} work order selected",
  "production.bulk.many": "{n} work orders selected",
  "production.bulk.export": "Export",
  "production.bulk.release": "Release drafts",
  "production.bulk.clear": "Clear selection",
  "production.menu.more": "More",
  "production.menu.open": "Open",
  "production.menu.release": "Release",
  "production.menu.complete": "Complete",
  "production.select": "Select {name}",
  "production.range": "{from}–{to} of {total}",
  "production.back": "All work orders",
  "production.missing": "This work order is not in the list.",
  "production.planned": "Planned",
  "production.actual": "Actual",
  "production.qtyGood": "Good / order",
  "production.goodScrap": "Good / scrap",
  "production.orderQty": "Order {n}",
  "production.actions": "Start / finish",
  "production.shopDetail": "Operations, materials and cost stay hidden while shop-floor tracking is off.",
  "production.notice.released": "Released {n} draft.",
  "production.notice.releasedMany": "Released {n} drafts.",
  "production.notice.none": "Only drafts can be released.",
  "production.notice.completed": "Work order completed.",
  "production.cost.perGood": "Per good unit",
  "production.cost.variance": "Cost variance",
  "production.cost.hoursVar": "Hours variance",
  "production.setupRun": "Setup {setup} · run {run}",
  "production.section.operations": "Operations",
  "production.section.materials": "Materials",
  "production.section.cost": "Cost",
  // Settings · Process recipes (#80)
  "proc.tab": "Process recipes",
  "proc.title": "Process recipes",
  "proc.blurb": "New RFQ lines copy their operations, setup and run hours from these recipes. Editing a recipe does not change lines it was already applied to.",
  "proc.new": "New recipe",
  "proc.loading": "Loading…",
  "proc.empty": "No recipes yet.",
  "proc.notLoaded": "Recipes are not loaded in this session.",
  "proc.seeded": "Default",
  "proc.custom": "Custom",
  "proc.opsCount": "{count} ops",
  "proc.pick": "Pick a recipe to edit, or create a new one.",
  "proc.code": "Code",
  "proc.codeHint": "A–Z, 0–9, _ or -. It cannot be changed later.",
  "proc.label": "Name",
  "proc.makeBuy": "Make or buy",
  "proc.leadDays": "Default lead time",
  "proc.days": "days",
  "proc.ops": "Operations",
  "proc.col.op": "Op code",
  "proc.col.label": "Name",
  "proc.col.setup": "Setup h",
  "proc.col.run": "Run h/unit",
  "proc.col.machine": "Machine",
  "proc.col.actions": "Order and remove",
  "proc.addOp": "Add operation",
  "proc.moveUp": "Move up",
  "proc.moveDown": "Move down",
  "proc.removeOp": "Remove operation",
  "proc.noOps": "No operations. A recipe needs at least one.",
  "proc.params": "Parameters: {list}",
  "proc.save": "Save changes",
  "proc.create": "Create recipe",
  "proc.saving": "Saving…",
  "proc.revert": "Discard changes",
  "proc.keep": "Cancel",
  "proc.saved": "Recipe saved. New lines use it from now on.",
  "proc.created": "Recipe created.",
  "proc.delete": "Delete",
  "proc.deleteTitle": "Delete {code}?",
  "proc.deleteBody": "The recipe leaves the library. Lines it was already applied to keep their operations.",
  "proc.deleted": "Recipe deleted.",
  "proc.reset": "Reset to default",
  "proc.resetTitle": "Reset {code} to default?",
  "proc.resetBody": "Your changes to this recipe are replaced with the shipped default. Lines it was already applied to keep their operations.",
  "proc.resetDone": "Recipe reset to default.",
  "proc.discardTitle": "Discard unsaved changes?",
  "proc.discardBody": "Your edits to this recipe are not saved.",
  "proc.discard": "Discard",
  "proc.busy": "Working…",
  "proc.err.load": "Could not load recipes: {message}",
  "proc.err.generic": "Could not complete the request: {message}",
  "proc.err.body": "The request was malformed.",
  "proc.err.fieldUnknown": "Unknown field: {field}",
  "proc.err.code": "Use 1–32 characters: A–Z, 0–9, _ or -, starting with a letter or digit.",
  "proc.err.codeTaken": "A recipe with this code already exists.",
  "proc.err.codeMismatch": "The code does not match this recipe.",
  "proc.err.label": "Enter a name of up to 120 characters.",
  "proc.err.makeBuy": "Pick make, buy or outsource.",
  "proc.err.leadDays": "Enter whole days from 0 to 365.",
  "proc.err.sortOrder": "The order must be a whole number of 0 or more.",
  "proc.err.route": "A recipe needs 1 to 50 operations.",
  "proc.err.op": "This operation is malformed.",
  "proc.err.opCode": "Op code: 1–32 characters, A–Z, 0–9, _ or -.",
  "proc.err.opCodeDuplicate": "This op code is already used in this recipe.",
  "proc.err.hours": "Enter hours as a number from 0 to 1000.",
  "proc.err.hoursDriven": "This time is computed from the operation's parameters ({value} h). Enter that value or change the parameters.",
  "proc.err.opField": "Invalid value in {field}.",
  "proc.err.seeded": "Default recipes cannot be deleted. Reset them instead.",
  "proc.err.notSeeded": "Only default recipes can be reset.",
  "proc.err.notFound": "This recipe no longer exists.",
  // Agents page
  "sidebar.hint.agents": "RFQ agents and what waits for you",
  "agents.subtitle": "Agents read each RFQ, check it and prepare the quote. They stop wherever a person has to decide.",
  "agents.autorunOn": "Starts on every new RFQ",
  "agents.autorunOff": "Starts when you run it on an RFQ",
  "agents.waiting": "Waiting for you",
  "agents.waitingEmpty": "Agents aren't waiting on you.",
  "agents.waitingEmptyHint": "An RFQ shows up here when it reaches a step only a person can do.",
  "agents.open": "Open",
  "agents.untitled": "Untitled RFQ",
  "agents.working": "In progress",
  "agents.workingQueued": "Queued",
  "agents.workingRun": "Running",
  "agents.workingJob": "Reading files",
  "agents.failedLabel": "Stopped",
  "agents.failed": "An agent hit an error. Try again; if it stops again, open the RFQ.",
  "agents.inbox": "RFQ inbox",
  "agents.inboxHint": "Customers send RFQs to this address. Each mail opens a draft RFQ.",
  "agents.inboxOff": "Mail receiving is off for this workspace.",
  "agents.inboxUnconfigured": "The inbound mail domain is not set up on the server yet.",
  "agents.inboxError": "The address could not be loaded.",
  "agents.notStarted": "Not started yet",
  "agents.notStartedHint": "Open RFQs the agents have not run on",
  "agents.start": "Run the agents",
  "agents.retry": "Try again",
  "agents.retrying": "Starting…",
  "agents.steps": "Steps",
  "agents.stepsHide": "Hide steps",
  "agents.stepsNone": "The agents have not run on this RFQ yet.",
  "agents.stepsError": "The steps could not be loaded.",
  "rfq.err.readOnly": "Your role can only view. Ask an editor or the owner to do this.",
  "agents.copy": "Copy",
  "agents.copied": "Copied",
  "agents.external": "Outside agents",
  "agents.externalHint": "Connect Cursor or Claude on this computer. They can read and prepare work; approvals and sending stay here.",
  "agents.lineup": "What the agents do",
  "agents.lineupHint": "In this order, for every RFQ. Cost is plain calculation, not an agent.",
  "agents.noStop": "Does not stop",
  "agents.step.intake.name": "Intake",
  "agents.step.intake.does": "Reads the mail, sheets, photos and drawings and splits the request into lines.",
  "agents.step.intake.stop": "A value read off a scan needs your OK.",
  "agents.step.geometry.name": "Geometry",
  "agents.step.geometry.does": "Picks the measurement when the reading methods disagree, or says it is unsure.",
  "agents.step.geometry.stop": "The reading methods disagree.",
  "agents.step.triage.name": "Triage",
  "agents.step.triage.does": "Finds what is missing or contradicts and drafts the question to the customer.",
  "agents.step.triage.stop": "You send the question.",
  "agents.step.stock.name": "Material & stock",
  "agents.step.stock.does": "Matches stock and suggests a substitute that needs the customer's OK.",
  "agents.step.make_buy.name": "Make or buy",
  "agents.step.make_buy.does": "Plans each line: make it in the shop or buy it, and the route.",
  "agents.step.supplier.name": "Supplier",
  "agents.step.supplier.does": "Drafts the supplier question for bought or outsourced lines.",
  "agents.step.supplier.stop": "Waits for the supplier price.",
  "agents.step.cost.name": "Cost",
  "agents.step.cost.does": "Plain calculation: setup + run × quantity, material, labour and machine.",
  "agents.step.audit.name": "Auditor",
  "agents.step.audit.does": "Catches contradictions inside the quote, such as a due date shorter than the material lead time.",
  "agents.step.audit.stop": "A contradiction has to be fixed.",
  "agents.step.margin.name": "Margin",
  "agents.step.margin.does": "Suggests a margin from your rules.",
  "agents.step.margin.stop": "You approve the margin.",
  "agents.step.send.name": "Send",
  "agents.step.send.does": "The quote is ready. Only a person sends it.",
  "agents.step.send.stop": "You send the quote.",
  "agents.gate.intake_pending": "Files are still being read",
  "agents.gate.parse_pending": "A drawing is still being read",
  "agents.gate.ocr_unconfirmed": "Confirm values read off a scan",
  "agents.gate.intake_blocker": "Resolve a conflicting or unreadable file",
  "agents.gate.no_lines": "Add a drawing, a sheet or lines",
  "agents.gate.parse_failed": "A drawing could not be read; upload it again",
  "agents.gate.geometry_uncertain": "Review the geometry decision",
  "agents.gate.customer_question": "Send the drafted question to the customer",
  "agents.gate.supplier_reply": "Enter the supplier price",
  "agents.gate.audit_blocker": "Fix what the auditor found",
  "agents.gate.margin_approval": "Approve the margin",
  "agents.gate.quote_send": "Send the quote",
  "agents.gate.unknown": "Open the RFQ to see the next step",
} as const;

export type MessageKey = keyof typeof en;
export type Messages = Record<MessageKey, string>;
